import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputSwitch } from 'primereact/inputswitch';
import Service from '../../services';
import Authentication from '../../session';
import withRouter from '../../lib/withRouter';
import { Button } from 'primereact/button';
import { AddIcon2, FileAttachmentIcon, MailIcon } from '../../svgIcons';
import ClassetInputText from '../../../classetComponents/classetInputText';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import { getFormFields, isFormValid, onDropDownChange, onEmailChange, onTextChange } from '../../../utile/formHelper';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Toast } from 'primereact/toast';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import ClassetCalendar from '../../../classetComponents/classetCalender';
import { getBoardsData, getBranchesLatest } from '../../../store/actions';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import { Dialog } from 'primereact/dialog';
import './styles.scss';
import { paymentModes } from '../../../constants';
import LoadingComponent from '../../loadingComponent';
import { trimObj } from '../../../utile';
import FileUpload from '../../fileUpload';
import FeeReciept from '../receipt';
import Axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import asymmetricEncryptionUtils from '../../../utils/asymmetricEncryptionUtils';
import { Column } from 'react-formio/lib/types';
import { DataTable } from 'primereact/datatable';
import { ProgressSpinner } from 'primereact/progressspinner';
import PopulateDynamicForm from '../../../classetComponents/classetPopulateDynamicForm';

import countryPhoneCodes from '../../../constants/countryPhoneCodes.json';
import countries from '../../../constants/countries.json';
import motherTongue from '../../../constants/motherTongue.json';
import castes from '../../../constants/castes.json';
import religions from '../../../constants/religions.json';
import states from '../../../constants/states.json';
import cityOrDist from '../../../constants/cityOrDist.json';
import districts from '../../../constants/districts.json';
import area from '../../../constants/area.json';
import gradesEnum from '../../../constants/grades.json';
import NTTPaymentComponent from '../../financeManagement/NTTPaymentComponent';


const createFields = require('./collectFee.json');
const createApplicationFields = require('./applicationCreate.json');
// import gradesEnum from '../../../constants/grades.json';

const awsRegion = process.env.REACT_APP_AWS_REGION || 'ap-south-1';
const profilesBucket = process.env.REACT_APP_PROFILES_BUCKET || 'classet-profiles-old';

const formFields = createApplicationFields;
class ApplicationCreate extends Component {


    constructor(props) {
        super(props);

        // Check for referenceNo in URL immediately
        const urlParams = new URLSearchParams(window.location.search);
        const referenceNo = urlParams.get('referenceNo');

        console.log('🚀 Constructor: URL contains referenceNo =', referenceNo);

        this.formFields = getFormFields(createApplicationFields);
        this.payformFields = getFormFields(createFields);

        const transformedCountryPhoneCodes = countryPhoneCodes.map(country => ({
            label: `${country.country} (+${country.code})`,
            value: country.code,
            country: country.country,
            iso: country.iso
        }));

        const transformedMotherTongue = motherTongue.map(lang => ({
            label: lang.label,
            value: lang.value
        }));

        const transformedCastes = castes.map(caste => ({
            label: caste.label,
            value: caste.value
        }));

        const transformedReligions = religions.map(religion => ({
            label: religion.label,
            value: religion.value
        }));

        const transformedCountries = countries.map(country => ({
            name: country.name,
            code: country.code
        }));

        const transformedStates = states.map(state => ({
            label: state.label,
            value: state.value
        }));

        const transformedCityOrDist = cityOrDist.map(city => ({
            label: city.label,
            value: city.value
        }));

        const transformedArea = area.map(area => ({
            label: area.label,
            value: area.value
        }));

        // Transform grades from grades.json for classStudyingDrp
        const transformedGrades = Object.entries(gradesEnum).map(([label, value]) => ({
            label: label,
            value: value
        }));

        const isEditing = this.props?.selectedEnquiry?._id;

        // In constructor, update the initialAddressData section to include academicYearCode:
        let initialAcademicData = {
            academicYearCode: ''
        };

        // Check if we have academic year code data
        if (this.props?.editApplication?.academicYearCode) {
            initialAcademicData.academicYearCode = this.props.editApplication.academicYearCode;
        } else if (this.props?.editApplication?.enquiry?.academicYearCode) {
            initialAcademicData.academicYearCode = this.props.editApplication.enquiry.academicYearCode;
        }

        // Fix the parents initialization
        let initialParents = [
            {
                parentType: '',
                parentName: '',
                qualification: '',
                profession: '',
                parentQualification: '',
                occupation: '',
                countryCode: '',
                parentContact: '',
                parentEmailId: '',
            }
        ];
        // Fix the siblings initialization
        let initialSiblings = [
            { name: "", gender: "", classStudying: "", schoolStudying: "" }
        ];

        // **NEW: Initialize address fields**
        let initialAddressData = {
            addressLine: '',
            pinCode: '',
            state: '',
            cityOrDist: ''
        };

        // **NEW: Initialize transport fields**
        let initialTransportData = {
            transportRequired: false,
            requestedStop: ''
        };
        // Check if we have transport data
        if (this.props?.editApplication?.transportRequired !== undefined) {
            initialTransportData = {
                transportRequired: this.props.editApplication.transportRequired,
                requestedStop: this.props.editApplication.requestedStop || ''
            };
        } else if (this.props?.editApplication?.enquiry?.transportRequired !== undefined) {
            initialTransportData = {
                transportRequired: this.props.editApplication.enquiry.transportRequired,
                requestedStop: this.props.editApplication.enquiry.requestedStop || ''
            };
        }

        // **NEW: Initialize admission test fields**
        let initialAdmissionTestData = {
            admissionTest: false
        };
        // Check if we have admission test data
        if (this.props?.editApplication?.admissionTest !== undefined) {
            initialAdmissionTestData.admissionTest = this.props.editApplication.admissionTest;
        } else if (this.props?.editApplication?.enquiry?.admissionTest !== undefined) {
            initialAdmissionTestData.admissionTest = this.props.editApplication.enquiry.admissionTest;
        }

        // Check if we have application data with parents
        if (this.props?.editApplication?.parents?.length > 0) {
            initialParents = this.props.editApplication.parents;
        } else if (this.props?.editApplication?.enquiry?.parents?.length > 0) {
            initialParents = this.props.editApplication.enquiry.parents;
        }
        // Check if we have application data with siblings
        if (this.props?.editApplication?.siblings?.length > 0) {
            initialSiblings = this.props.editApplication.siblings;
        } else if (this.props?.editApplication?.enquiry?.siblings?.length > 0) {
            initialSiblings = this.props.editApplication.enquiry.siblings;
        }

        // **NEW: Check if we have address data**
        if (this.props?.editApplication?.addressLine) {
            initialAddressData = {
                addressLine: this.props.editApplication.addressLine || '',
                pinCode: this.props.editApplication.pinCode || '',
                state: this.props.editApplication.state || '',
                cityOrDist: this.props.editApplication.cityOrDist || ''
            };
        } else if (this.props?.editApplication?.enquiry?.addressLine) {
            initialAddressData = {
                addressLine: this.props.editApplication.enquiry.addressLine || '',
                pinCode: this.props.editApplication.enquiry.pinCode || '',
                state: this.props.editApplication.enquiry.state || '',
                cityOrDist: this.props.editApplication.enquiry.cityOrDist || ''
            };
        }


        this.state = {

            isLoading: false,
            feePlans: [],
            admissionType: [],
            payFeeFormData: this.payformFields.data,

            countryPhoneCodes: transformedCountryPhoneCodes,
            motherTongue: transformedMotherTongue,
            castes: transformedCastes,
            religions: transformedReligions,
            countries: transformedCountries,
            state: transformedStates,
            cityOrDist: transformedCityOrDist,
            area: transformedArea,
            parents: initialParents,
            parentValidations: [{}], // Validation state for each parent
            siblings: initialSiblings,

            // **NEW: Initialize application with all required data**
            application: this.props?.editApplication?._id ? {
                ...this.props.editApplication,
                ...initialAddressData,
                ...initialTransportData, // Add transport data
                ...initialAcademicData, // Add academic data
                ...initialAdmissionTestData // Add admission test data
            } : {
                ...this.formFields.data,
                ...initialAddressData,
                ...initialTransportData, // Add transport data
                ...initialAcademicData, // Add academic data
                ...initialAdmissionTestData // Add admission test data
            },




            govtIdTypes: [
                { label: "Aadhaar Card", value: "aadhaar" },
                { label: "Passport", value: "passport" },
                { label: "Other", value: "other" }
            ],

            gender: [
                { label: 'Male', value: 'male' },
                { label: 'Female', value: 'female' },
                { label: 'Other', value: 'other' }
            ],
            parentTypes: [
                { label: 'Father', value: 'Father' },
                { label: 'Mother', value: 'Mother' },
                { label: 'Guardian', value: 'Guardian' }
            ],

            previousBoards: [
                { label: "Central Board of Secondary Education (CBSE)", value: "CBSE" },
                { label: "Indian Certificate of Secondary Education (ICSE)", value: "ICSE" },
                { label: "International Baccalaureate (IB)", value: "IB" },
                { label: "Cambridge Assessment International Education (IGCSE)", value: "IGCSE" },
                { label: "State Board", value: "State" },
                { label: "National Institute of Open Schooling (NIOS)", value: "NIOS" },
                { label: "Council for the Indian School Certificate Examinations (CISCE)", value: "CISCE" },
                { label: "Other", value: "Other" },
            ],

            payFee: this.payformFields.data,
            formValidations: this.formFields.formValidations,
            payFormValidations: this.payformFields.formValidations,
            addDifferentialFeeAllow: false,
            selectedEnquiry: {},
            isAddApplication: false,
            academicCategory: [],
            academicSession: [],
            isEdit: false,
            boards: [],
            isExam: false,
            createdId: null,
            isShowReceipt: false,
            isApplicationFeePaid: false,
            receiptInfo: {},
            isShowPayFeeButton: false,
            isPaymentJustCompleted: false, // Flag to track if payment was just completed
            loadedFromReferenceNo: !!urlParams.get('referenceNo'), // Track if loaded from URL
            // isShowPayFeeButton: true,

            genderData: [
                { label: "Male", value: "male" },
                { label: "Female", value: "female" }
            ],
            classStudyingDrp: transformedGrades,
        };
        this.service = new Service();
    }

    // Check if application fee is paid and show payment dialog if not
    // Helper method to safely show toast messages
    showToast = (severity, summary, detail, life = 3000) => {
        if (this.toast && this.toast.show) {
            this.toast.show({ severity, summary, detail, life });
        } else {
            console.log(`Toast: ${severity.toUpperCase()} - ${summary}: ${detail}`);
        }
    };

    // Check for URL parameter changes
    componentDidUpdate(prevProps) {
        const currentSearch = window.location.search;
        const prevSearch = prevProps.location?.search || '';

        // Check if URL search parameters changed
        if (currentSearch !== prevSearch) {
            const urlParams = new URLSearchParams(currentSearch);
            const referenceNo = urlParams.get('referenceNo');

            if (referenceNo) {
                this.getApplicationByReferenceNo(referenceNo);
            }
        }
    }

    checkApplicationFeePaidStatus = async () => {
        try {
            // First check if application fee is configured by calling handlePayFee
            // This will set isShowPayFeeButton based on whether fee exists
            await this.handlePayFee(false);

            // Use setTimeout to ensure state has been updated before checking
            setTimeout(async () => {
                // If no fee is configured, don't show the dialog
                if (!this.state.isShowPayFeeButton) {
                    console.log("No application fee configured. Skipping fee dialog.");
                    return;
                }

                console.log("Application fee is configured. Checking payment status...");

                // First check if we have an application ID
                if (this.props?.editApplication?._id || this.state.application?._id) {
                    const applicationId = this.props?.editApplication?._id || this.state.application?._id;

                    // Check fee payment status for existing application
                    const url = `${baseUrlAdmin}/admissions/feePaidInfo?_id=${applicationId}`;
                    const res = await this.service.get(url, true);

                    if (res && res.status && res.res.status) {
                        const receiptInfo = res.res.data;
                        const isFeePaid = receiptInfo?.isApplicationFeePaid || false;

                        this.setState({ isApplicationFeePaid: isFeePaid });

                        // If fee is not paid and we have fee configuration, show payment dialog
                        if (!isFeePaid) {
                            console.log("Fee not paid. Opening payment dialog...");
                            this.openDailogPayAppFee();
                        } else {
                            console.log("Fee already paid. Skipping dialog.");
                        }
                    } else {
                        // Fee not paid, show dialog
                        console.log("Could not get fee status. Opening payment dialog...");
                        this.setState({ isApplicationFeePaid: false });
                        this.openDailogPayAppFee();
                    }
                } else {
                    // For new applications, show dialog as fee is required
                    console.log("New application. Opening payment dialog...");
                    this.setState({ isApplicationFeePaid: false });
                    this.openDailogPayAppFee();
                }
            }, 300); // Wait 300ms for state to update
        } catch (error) {
            console.error('Error checking application fee status:', error);
            this.setState({ isApplicationFeePaid: false });
        }
    };

    onChangeInput = (value, index, field, arr) => {
        if (arr === "siblings") {
            let data = [...this.state.siblings];
            data[index][field] = value;
            this.setState({ siblings: data });
        }
    };

    onCliclAddSibling = (add, index) => {
        if (add) {
            let arrLength = this.state.siblings.length;
            let lastObj = this.state.siblings[arrLength - 1];
            if (lastObj.name !== "") {
                this.setState((prevState) => ({
                    siblings: [...prevState.siblings, { name: "", gender: "", classStudying: "", schoolStudying: "" }]
                }));
            } else {
                this.toast.show({ severity: 'error', summary: 'Please enter the sibling details', detail: '', life: 3000 });
            }
        } else {
            const { siblings } = this.state;
            if (siblings.length > 1) {
                const newArr = [...siblings];
                newArr.splice(index, 1);
                this.setState({ siblings: newArr });
            }
        }
    };

    addParent = () => {
        this.setState((prevState) => ({
            parents: [
                ...prevState.parents,
                {
                    parentType: '',
                    parentName: '',
                    qualification: '',
                    profession: '',
                    parentQualification: '',
                    occupation: '',
                    countryCode: '',
                    parentContact: '',
                    parentEmailId: '',
                }
            ],
            parentValidations: [...prevState.parentValidations, {}]
        }));
    };

    removeParent = (index) => {
        this.setState((prevState) => {
            const updatedParents = [...prevState.parents];
            updatedParents.splice(index, 1);
            const updatedValidations = prevState.parentValidations.filter((_, i) => i !== index);
            return { parents: updatedParents, parentValidations: updatedValidations };
        });
    };

    // Contact number validation - exactly 10 digits
    onContactNumberChange = (value, fieldName) => {
        const numericValue = value.replace(/\D/g, '').slice(0, 10);

        let validation = { isValid: true, errorMsg: '' };

        if (numericValue && numericValue.length < 10) {
            validation = {
                isValid: false,
                errorMsg: 'Contact number must be exactly 10 digits'
            };
        } else if (numericValue && numericValue.length === 10) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            application: {
                ...prevState.application,
                [fieldName]: numericValue
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    [fieldName]: validation
                }
            }
        }));
    };

    // Email validation with proper format check
    onEmailChangeWithValidation = (value, fieldName) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let validation = { isValid: true, errorMsg: '' };

        if (value && !emailRegex.test(value)) {
            validation = {
                isValid: false,
                errorMsg: 'Please enter a valid email address'
            };
        } else if (value) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            application: {
                ...prevState.application,
                [fieldName]: value
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    [fieldName]: validation
                }
            }
        }));
    };

    // Pincode validation - exactly 6 digits
    onPincodeChange = (value) => {
        const numericValue = value.replace(/\D/g, '').slice(0, 6);

        let validation = { isValid: true, errorMsg: '' };

        if (numericValue && numericValue.length < 6) {
            validation = {
                isValid: false,
                errorMsg: 'Pincode must be exactly 6 digits'
            };
        } else if (numericValue && numericValue.length === 6) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            application: {
                ...prevState.application,
                pinCode: numericValue
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    pinCode: validation
                }
            }
        }));
    };

    onParentChange = (value, index, field) => {
        const updatedParents = [...this.state.parents];
        let validationError = null;

        // Apply validation for specific fields
        if (field === 'parentContact') {
            const numericValue = value.replace(/\D/g, '').slice(0, 10);
            updatedParents[index][field] = numericValue;

            if (numericValue && numericValue.length < 10) {
                validationError = 'Contact number must be exactly 10 digits';
            }
        } else if (field === 'parentEmailId') {
            updatedParents[index][field] = value;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (value && !emailRegex.test(value)) {
                validationError = 'Please enter a valid email address';
            }
        } else {
            updatedParents[index][field] = value;
        }

        // Update parent validations
        const updatedParentValidations = [...this.state.parentValidations];
        if (!updatedParentValidations[index]) {
            updatedParentValidations[index] = {};
        }
        updatedParentValidations[index][field] = {
            isValid: !validationError,
            errorMsg: validationError || ''
        };

        // Sync qualification fields - when parentQualification changes, update qualification too
        if (field === 'parentQualification' || field === 'qualification') {
            updatedParents[index]['qualification'] = value;
            updatedParents[index]['parentQualification'] = value;
        }
        // Sync occupation fields - when occupation changes, update profession too  
        if (field === 'occupation' || field === 'profession') {
            updatedParents[index]['profession'] = value;
            updatedParents[index]['occupation'] = value;
        }

        const updatedApplication = { ...this.state.application };

        // Only sync the first parent's data to the application object for validation and backward compatibility
        if (index === 0) {
            if (field === 'parentType') updatedApplication.parentType = value;
            if (field === 'parentName') updatedApplication.parentName = value;
            if (field === 'parentQualification' || field === 'qualification') {
                updatedApplication.parentQualification = value;
                updatedApplication.qualification = value; // Also update qualification field
            }
            if (field === 'occupation' || field === 'profession') {
                updatedApplication.occupation = value;
                updatedApplication.profession = value; // Also update profession field
            }
            if (field === 'countryCode') updatedApplication.countryCode = value;

            if (field === 'parentContact') {
                // Use the validated/formatted value from updatedParents
                updatedApplication.parentContact = updatedParents[0][field];
                updatedApplication.contactNo = updatedParents[0][field]; // Backward compatibility
            }
            if (field === 'parentEmailId') {
                updatedApplication.parentEmailId = value;
                updatedApplication.emailId = value; // Backward compatibility
            }
        }

        const updatedFormValidations = { ...this.state.formValidations };
        if (index === 0 && this.formFields.formValidations.fields[field]) {
            updatedFormValidations.fields[field] = {
                isValid: !validationError,
                errorMsg: validationError || ''
            };
        }

        this.setState({
            parents: updatedParents,
            parentValidations: updatedParentValidations,
            application: updatedApplication,
            formValidations: updatedFormValidations
        });
    };


    _onStudentPhotoSuccess = (fileName, data) => {
        this.addAttachment('studentPhoto', fileName, data);
    };

    validateIdDetails = (value, govtIdType) => {
        if (!value) return { isValid: true, errorMsg: '' };

        switch (govtIdType) {
            case 'aadhaar':
                const aadhaarRegex = /^\d{12}$/;
                if (!aadhaarRegex.test(value)) {
                    return {
                        isValid: false,
                        errorMsg: 'Aadhaar number must be exactly 12 digits'
                    };
                }
                break;
            case 'passport':
                const passportRegex = /^[A-Za-z0-9]{8}$/;
                if (!passportRegex.test(value)) {
                    return {
                        isValid: false,
                        errorMsg: 'Passport number must be exactly 8 alphanumeric characters'
                    };
                }
                break;
            default:
                return { isValid: true, errorMsg: '' };
        }
        return { isValid: true, errorMsg: '' };
    };

    onIdDetailsChange = (value) => {
        const { application } = this.state;
        const validation = this.validateIdDetails(value, application.govtIdType);

        this.setState(prevState => ({
            application: {
                ...prevState.application,
                idDetails: value
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    idDetails: validation
                }
            }
        }));
    };

    onGovtIdTypeChange = (value) => {
        const { application } = this.state;

        this.setState(prevState => ({
            application: {
                ...prevState.application,
                govtIdType: value,
                idDetails: ''
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    govtIdType: { isValid: true, errorMsg: '' },
                    idDetails: { isValid: true, errorMsg: '' }
                }
            }
        }));
    };


    async componentDidMount() {

        // Check for payment status in URL (after redirect from payment gateway)
        const urlParams = new URLSearchParams(window.location.search);
        const paymentStatus = urlParams.get('status');
        const txnId = urlParams.get('txnId');
        const atomTxnId = urlParams.get('atomTxnId');
        const referenceNo = urlParams.get('referenceNo');

        // Handle payment redirect
        if (paymentStatus) {
            // Load essential data before handling payment
            await this.getAdmissionSettingsInfo();
            this.props.getBranchesLatest();
            this.props.getBoardsData(true);
            await this.getAdmissionTypeDropdown();
            await this.getAcademicSessions();

            await this.handlePaymentRedirect(paymentStatus, txnId, atomTxnId, referenceNo);
            // Skip remaining componentDidMount logic - state already restored from sessionStorage
            return;
        }

        //Check if application fee is paid and show payment dialog if not paid
        await this.checkApplicationFeePaidStatus();

        const applicationId = await localStorage.getItem('applicationId')
        const enquiryId = await localStorage.getItem('enquiryId');

        await this.getAdmissionSettingsInfo();
        this.props.getBranchesLatest();
        this.props.getBoardsData(true);
        await this.getAdmissionTypeDropdown();
        await this.getAcademicSessions();

        // Fetch data based on referenceNo if present in URL (highest priority)
        if (referenceNo) {
            console.log('Loading application form for referenceNo from URL:', referenceNo);
            await this.getApplicationByReferenceNo(referenceNo);
        } else if (this.props?.editApplication?.referenceNo) {
            // Check if referenceNo is passed via editApplication prop
            console.log('Loading application form for referenceNo from editApplication prop:', this.props.editApplication.referenceNo);
            await this.getApplicationByReferenceNo(this.props.editApplication.referenceNo);
        } else if (enquiryId) {
            await this.getEnquiryInfo(enquiryId);
        }

        if (this.props?.editApplication?._id) {
            await this.onChangeBranch(this.props?.editApplication?.branch)
            await this.onChangeBoard(this.props?.editApplication?.board)

            let academicData = {};
            // Extract academic year code
            if (this.props.editApplication?.academicYearCode) {
                academicData.academicYearCode = this.props.editApplication.academicYearCode;
            } else if (this.props.editApplication?.enquiry?.academicYearCode) {
                academicData.academicYearCode = this.props.editApplication.enquiry.academicYearCode;
            }

            // **NEW: Properly set parents data from enquiry**
            let parentsData = [];
            if (this.props.editApplication?.parents?.length > 0) {
                parentsData = this.props.editApplication.parents;
            } else if (this.props.editApplication?.enquiry?.parents?.length > 0) {
                parentsData = this.props.editApplication.enquiry.parents;
            }

            let siblingsData = [];
            if (this.props.editApplication?.siblings?.length > 0) {
                siblingsData = this.props.editApplication.siblings;
            } else if (this.props.editApplication?.enquiry?.siblings?.length > 0) {
                siblingsData = this.props.editApplication.enquiry.siblings;
            }

            let addressData = {};

            // **NEW: Extract address data**
            if (this.props.editApplication?.addressLine) {
                addressData = {
                    addressLine: this.props.editApplication.addressLine,
                    pinCode: this.props.editApplication.pinCode,
                    state: this.props.editApplication.state,
                    cityOrDist: this.props.editApplication.cityOrDist
                };
            } else if (this.props.editApplication?.enquiry?.addressLine) {
                addressData = {
                    addressLine: this.props.editApplication.enquiry.addressLine,
                    pinCode: this.props.editApplication.enquiry.pinCode,
                    state: this.props.editApplication.enquiry.state,
                    cityOrDist: this.props.editApplication.enquiry.cityOrDist
                };
            }

            // Load districts for edit mode if state is selected
            if (addressData.state) {
                const selectedState = addressData.state;
                const selectedStateDistricts = districts[selectedState] || [];

                // Transform districts to dropdown format with {label, value}
                let transformedDistricts = selectedStateDistricts.map(district => ({
                    label: district,
                    value: district
                }));

                // If no districts found for the selected state, add "Other" option
                if (transformedDistricts.length === 0) {
                    transformedDistricts = [{ label: 'Other', value: 'Other' }];
                }

                this.setState({
                    cityOrDist: transformedDistricts
                });
            }


            let transportData = {};
            // **NEW: Extract transport data**
            if (this.props.editApplication?.transportRequired !== undefined) {
                transportData = {
                    transportRequired: this.props.editApplication.transportRequired,
                    requestedStop: this.props.editApplication.requestedStop || ''
                };
            } else if (this.props.editApplication?.enquiry?.transportRequired !== undefined) {
                transportData = {
                    transportRequired: this.props.editApplication.enquiry.transportRequired,
                    requestedStop: this.props.editApplication.enquiry.requestedStop || ''
                };
            }

            // **NEW: Extract admission test data**
            let admissionTestData = {};
            if (this.props.editApplication?.admissionTest !== undefined) {
                admissionTestData.admissionTest = this.props.editApplication.admissionTest;
            } else if (this.props.editApplication?.enquiry?.admissionTest !== undefined) {
                admissionTestData.admissionTest = this.props.editApplication.enquiry.admissionTest;
            }

            this.setState(
                (prevState) => ({
                    application: {
                        ...prevState.application,
                        ...this.props.editApplication,
                        ...addressData, // **NEW: Merge address data**
                        ...transportData, // **NEW: Merge transport data**
                        ...academicData, // **NEW: Merge academic data**
                        ...admissionTestData // **NEW: Merge admission test data**
                    },
                    parents: parentsData.length > 0 ? parentsData : prevState.parents,
                    siblings: siblingsData.length > 0 ? siblingsData : prevState.siblings,

                    isEdit: true
                }),
                async () => {
                    await this.handlePayFee(false);

                    // Check application fee status only for editing existing applications
                    // For new applications, fee check is already done in main componentDidMount
                    if (this.props?.editApplication?._id) {
                        await this.checkApplicationFeePaidStatus();
                    }
                }
            );
        }
    }

    getAdmissionSettingsInfo = async () => {
        this.setState({
            isLoading: true
        });
        let academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admissions/process?academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                this.setState({ admissionSettingsInfo: res?.res?.data, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    };

    handlePayFee = async (isContinue) => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/application-fee/filter`;
        try {
            let payload = {
                isActive: true,
                academicYear: this.state.application?.academicSession,
                orgId: this.state.application?.orgId,
                board: this.state.application?.board,
                grade: this.state.application?.grade,
                admissionStep: 'Application'
            };
            const res = await this.service.post(url, payload, true);
            if (res?.res?.status && res.status) {
                this.setState({
                    feePayInfo: res?.res?.data,
                    isShowPayFeeButton: res?.res?.data && Object.keys(res?.res?.data).length ? true : false,
                    isLoading: false
                }, () => {
                    // Only call onCheckFeePaidInfo if isContinue is true (after successful payment)
                    // Don't call it during component mount or fee configuration check
                    if (isContinue) {
                        this.onCheckFeePaidInfo(isContinue);
                    }
                });
            } else {
                this.setState({
                    isLoading: false
                });
                // this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    };

    getApplicationByReferenceNo = async (referenceNo) => {
        console.log('🔍 Starting getApplicationByReferenceNo for:', referenceNo);
        this.setState({
            isLoading: true
        });

        let url = `${baseUrlAdmin}/admissions/form?referenceNo=${referenceNo}`;

        try {
            const res = await this.service.get(url, true);

            console.log('📡 API Response for referenceNo:', res);

            if (res && res.status && res.res.status) {
                if (res.res.data && res.res.data.admissionRecords.length) {
                    // Handle nested array structure: admissionRecords[0][0] or admissionRecords[0]
                    let admissionRecord = res.res.data.admissionRecords[0];

                    // Check if it's a nested array and extract the actual record
                    if (Array.isArray(admissionRecord) && admissionRecord.length > 0) {
                        admissionRecord = admissionRecord[0];
                        console.log('📦 Extracted from nested array structure');
                    }

                    console.log('📋 Application data found:', admissionRecord);

                    // Extract academic year code (same logic as getEnquiryInfo)
                    let academicData = {};
                    if (admissionRecord?.enquiry?.academicYearCode) {
                        academicData.academicYearCode = admissionRecord.enquiry.academicYearCode;
                    } else if (admissionRecord?.academicYearCode) {
                        academicData.academicYearCode = admissionRecord.academicYearCode;
                    }

                    // Process parents data (same logic as getEnquiryInfo)
                    let parentsData = [];
                    if (admissionRecord?.enquiry?.parents?.length > 0) {
                        parentsData = admissionRecord.enquiry.parents;
                    } else if (admissionRecord?.parents?.length > 0) {
                        parentsData = admissionRecord.parents;
                    } else {
                        parentsData = [{
                            parentType: '',
                            parentName: '',
                            qualification: '',
                            profession: '',
                            parentQualification: '',
                            occupation: '',
                            countryCode: '',
                            parentContact: '',
                            parentEmailId: '',
                        }];
                    }

                    // Process siblings data (same logic as getEnquiryInfo)
                    let siblingsData = [];
                    if (admissionRecord?.enquiry?.siblings?.length > 0) {
                        siblingsData = admissionRecord.enquiry.siblings;
                    } else if (admissionRecord?.siblings?.length > 0) {
                        siblingsData = admissionRecord.siblings;
                    } else {
                        siblingsData = [{ name: "", gender: "", classStudying: "", schoolStudying: "" }];
                    }

                    // Extract address data (same logic as getEnquiryInfo)
                    let addressData = {};
                    if (admissionRecord?.enquiry?.addressLine) {
                        addressData = {
                            addressLine: admissionRecord.enquiry.addressLine,
                            pinCode: admissionRecord.enquiry.pinCode,
                            state: admissionRecord.enquiry.state,
                            cityOrDist: admissionRecord.enquiry.cityOrDist
                        };
                    } else if (admissionRecord?.addressLine) {
                        addressData = {
                            addressLine: admissionRecord.addressLine,
                            pinCode: admissionRecord.pinCode,
                            state: admissionRecord.state,
                            cityOrDist: admissionRecord.cityOrDist
                        };
                    }

                    // Load districts for the selected state (same logic as getEnquiryInfo)
                    if (addressData.state) {
                        const selectedState = addressData.state;
                        const selectedStateDistricts = districts[selectedState] || [];
                        let transformedDistricts = selectedStateDistricts.map(district => ({
                            label: district,
                            value: district
                        }));
                        if (transformedDistricts.length === 0) {
                            transformedDistricts = [{ label: 'Other', value: 'Other' }];
                        }
                        this.setState({
                            cityOrDist: transformedDistricts
                        });
                    }

                    // Extract transport data (same logic as getEnquiryInfo)
                    let transportData = {};
                    if (admissionRecord?.enquiry?.transportRequired !== undefined) {
                        transportData = {
                            transportRequired: admissionRecord.enquiry.transportRequired,
                            requestedStop: admissionRecord.enquiry.requestedStop || ''
                        };
                    } else if (admissionRecord?.transportRequired !== undefined) {
                        transportData = {
                            transportRequired: admissionRecord.transportRequired,
                            requestedStop: admissionRecord.requestedStop || ''
                        };
                    }

                    // Extract admission test data (same logic as getEnquiryInfo)
                    let admissionTestData = {};
                    if (admissionRecord?.enquiry?.admissionTest !== undefined) {
                        admissionTestData.admissionTest = admissionRecord.enquiry.admissionTest;
                    } else if (admissionRecord?.admissionTest !== undefined) {
                        admissionTestData.admissionTest = admissionRecord.admissionTest;
                    }

                    // Extract and validate DOB (same logic as getEnquiryInfo)
                    let dobValue = null;
                    if (admissionRecord?.enquiry?.dob) {
                        const dobDate = new Date(admissionRecord.enquiry.dob);
                        if (!isNaN(dobDate.getTime()) && dobDate.getFullYear() > 1970) {
                            dobValue = admissionRecord.enquiry.dob;
                        }
                    } else if (admissionRecord?.dob) {
                        const dobDate = new Date(admissionRecord.dob);
                        if (!isNaN(dobDate.getTime()) && dobDate.getFullYear() > 1970) {
                            dobValue = admissionRecord.dob;
                        }
                    }

                    console.log('📦 Setting state with application data:', {
                        application: {
                            ...admissionRecord,
                            ...addressData,
                            ...transportData,
                            ...academicData,
                            ...admissionTestData,
                            dob: dobValue
                        },
                        parents: parentsData,
                        siblings: siblingsData
                    });

                    this.setState({
                        isLoading: false,
                        application: {
                            ...admissionRecord,
                            ...addressData,     // Merge address data
                            ...transportData,   // Merge transport data
                            ...academicData,    // Merge academic data
                            ...admissionTestData, // Merge admission test data
                            dob: dobValue       // Set validated DOB
                        },
                        parents: parentsData,
                        siblings: siblingsData,
                        isEdit: true,
                        isAddApplication: true  // Force form to display in edit mode
                    }, async () => {
                        console.log('🎯 Application state updated, setting branch and board...');
                        console.log('📋 Current application state after setState:', this.state.application);
                        console.log('👨‍👩‍👧 Parents state:', this.state.parents);
                        console.log('👶 Siblings state:', this.state.siblings);

                        // Set branch and board data
                        if (this.state.application.branch) {
                            console.log('🏢 Setting branch:', this.state.application.branch);
                            await this.onChangeBranch(this.state.application.branch);
                        }
                        if (this.state.application.board) {
                            console.log('📚 Setting board:', this.state.application.board);
                            await this.onChangeBoard(this.state.application.board);
                        }

                        // Handle fee information
                        await this.handlePayFee(false);
                        await this.checkApplicationFeePaidStatus();

                        console.log('✅ Application form setup complete for referenceNo:', referenceNo);
                        console.log('📋 Final application state:', this.state.application);
                    });

                    // this.showToast('success', 'Data Loaded', `Application data loaded for reference: ${referenceNo}`);
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.showToast('warn', 'No Data Found', `No application found for reference number: ${referenceNo}`, 5000);
                }
            } else {
                this.setState({
                    isLoading: false
                });
                this.showToast('error', 'Error', res.errMessage || 'Failed to fetch application data');
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            console.error('Error fetching application by reference:', e);
            this.showToast('error', 'Error', 'Failed to load application data. Please try again.');
        }
    };

    getEnquiryInfo = async (enquiryId) => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/admissions/form?id=${enquiryId}`;
        this.service
            .get(url, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    if (res.res.data && res.res.data.admissionRecords.length) {
                        // Handle nested array structure: admissionRecords[0][0] or admissionRecords[0]
                        let admissionRecord = res.res.data.admissionRecords[0];

                        // Check if it's a nested array and extract the actual record
                        if (Array.isArray(admissionRecord) && admissionRecord.length > 0) {
                            admissionRecord = admissionRecord[0];
                            console.log('📦 getEnquiryInfo: Extracted from nested array structure');
                        }

                        let academicData = {};
                        // Extract academic year code from enquiry
                        if (admissionRecord?.enquiry?.academicYearCode) {
                            academicData.academicYearCode = admissionRecord.enquiry.academicYearCode;
                        } else if (admissionRecord?.academicYearCode) {
                            academicData.academicYearCode = admissionRecord.academicYearCode;
                        }

                        // **NEW: Extract parents data from enquiry**
                        let parentsData = [];
                        if (admissionRecord?.enquiry?.parents?.length > 0) {
                            parentsData = admissionRecord.enquiry.parents;
                        } else if (admissionRecord?.parents?.length > 0) {
                            parentsData = admissionRecord.parents;
                        }

                        let siblingsData = [];
                        if (admissionRecord?.enquiry?.siblings?.length > 0) {
                            siblingsData = admissionRecord.enquiry.siblings;
                        } else if (admissionRecord?.siblings?.length > 0) {
                            siblingsData = admissionRecord.siblings;
                        }

                        let addressData = {};
                        // **NEW: Extract address data from enquiry**
                        if (admissionRecord?.enquiry?.addressLine) {
                            addressData = {
                                addressLine: admissionRecord.enquiry.addressLine,
                                pinCode: admissionRecord.enquiry.pinCode,
                                state: admissionRecord.enquiry.state,
                                cityOrDist: admissionRecord.enquiry.cityOrDist
                            };
                        } else if (admissionRecord?.addressLine) {
                            addressData = {
                                addressLine: admissionRecord.addressLine,
                                pinCode: admissionRecord.pinCode,
                                state: admissionRecord.state,
                                cityOrDist: admissionRecord.cityOrDist
                            };
                        }

                        // Load districts for the selected state
                        if (addressData.state) {
                            const selectedState = addressData.state;
                            const selectedStateDistricts = districts[selectedState] || [];

                            // Transform districts to dropdown format with {label, value}
                            let transformedDistricts = selectedStateDistricts.map(district => ({
                                label: district,
                                value: district
                            }));

                            // If no districts found for the selected state, add "Other" option
                            if (transformedDistricts.length === 0) {
                                transformedDistricts = [{ label: 'Other', value: 'Other' }];
                            }

                            // Update the cityOrDist dropdown options before setting state
                            this.setState({
                                cityOrDist: transformedDistricts
                            });
                        }

                        let transportData = {};
                        // **NEW: Extract transport data from enquiry**
                        if (admissionRecord?.enquiry?.transportRequired !== undefined) {
                            transportData = {
                                transportRequired: admissionRecord.enquiry.transportRequired,
                                requestedStop: admissionRecord.enquiry.requestedStop || ''
                            };
                        } else if (admissionRecord?.transportRequired !== undefined) {
                            transportData = {
                                transportRequired: admissionRecord.transportRequired,
                                requestedStop: admissionRecord.requestedStop || ''
                            };
                        }

                        // **NEW: Extract admissionTest data from enquiry**
                        let admissionTestData = {};
                        if (admissionRecord?.enquiry?.admissionTest !== undefined) {
                            admissionTestData.admissionTest = admissionRecord.enquiry.admissionTest;
                        } else if (admissionRecord?.admissionTest !== undefined) {
                            admissionTestData.admissionTest = admissionRecord.admissionTest;
                        }

                        // Extract and validate DOB
                        let dobValue = null;
                        if (admissionRecord?.enquiry?.dob) {
                            const dobDate = new Date(admissionRecord.enquiry.dob);
                            // Check if the date is valid and not epoch (1/1/1970)
                            if (!isNaN(dobDate.getTime()) && dobDate.getFullYear() > 1970) {
                                dobValue = admissionRecord.enquiry.dob;
                            }
                        } else if (admissionRecord?.dob) {
                            const dobDate = new Date(admissionRecord.dob);
                            // Check if the date is valid and not epoch (1/1/1970)
                            if (!isNaN(dobDate.getTime()) && dobDate.getFullYear() > 1970) {
                                dobValue = admissionRecord.dob;
                            }
                        }

                        // Preserve board, grade (classId), and cityOrDist from enquiry
                        const boardFromEnquiry = admissionRecord?.board || admissionRecord?.enquiry?.board;
                        const gradeFromEnquiry = admissionRecord?.grade || admissionRecord?.enquiry?.grade;
                        const branchFromEnquiry = admissionRecord?.branch || admissionRecord?.enquiry?.branch;

                        this.setState(
                            {
                                isLoading: false,
                                application: {
                                    ...admissionRecord,
                                    ...addressData, // **NEW: Merge address data**
                                    ...transportData, // **NEW: Merge transport data**
                                    ...academicData, // **NEW: Merge academic data**
                                    ...admissionTestData, // **NEW: Merge admission test data**
                                    dob: dobValue, // Set validated DOB
                                    board: boardFromEnquiry, // Preserve board
                                    grade: gradeFromEnquiry, // Preserve grade
                                    branch: branchFromEnquiry // Preserve branch
                                },
                                parents: parentsData.length > 0 ? parentsData : this.state.parents,
                                siblings: siblingsData.length > 0 ? siblingsData : this.state.siblings

                            },
                            async () => {
                                // Load boards and classes for the selected branch and board
                                await this.onChangeBranch(branchFromEnquiry);
                                await this.onChangeBoard(boardFromEnquiry);

                                // After loading dropdowns, restore the board, grade, and cityOrDist values
                                this.setState(prevState => ({
                                    application: {
                                        ...prevState.application,
                                        board: boardFromEnquiry,
                                        grade: gradeFromEnquiry,
                                        cityOrDist: addressData.cityOrDist || prevState.application.cityOrDist
                                    },
                                    boardId: boardFromEnquiry,
                                    classId: gradeFromEnquiry
                                }), async () => {
                                    await this.handlePayFee(false);
                                    // Check application fee status for enquiry-based applications
                                    await this.checkApplicationFeePaidStatus();
                                    localStorage.removeItem('enquiryId');
                                });
                            }
                        );
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
                console.log(e);
            });
    };


    getAcademicSessions = async () => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/academic-years/filter`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const result = res?.res?.data?.map((admission) => ({
                    label: admission.academicCode,
                    value: admission._id
                }));
                this.setState({ academicSession: result, isLoading: false });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    };

    getAdmissionTypeDropdown = async () => {
        this.setState({
            isLoading: true
        });
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admission-types/active?academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const result = res?.res?.data?.map((admission) => ({
                    label: admission.categoryName,
                    value: admission._id
                }));

                this.setState({ academicCategory: result, isLoading: false });
            } else {
                this.setState({
                    isLoading: false
                });
                this.showToast('error', 'Error', 'Some error occurred');
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.showToast('error', 'Error', e.toString());
        }
    };

    onHandleNavigate = (isContinue) => {
        const { examTest, registration } = this.state?.admissionSettingsInfo || {};
        let createdId = this.state.createdId;
        if (isContinue && createdId) {
            localStorage.setItem('applicationId', createdId);
            // Check if exam test is enabled in settings AND user has selected admission test
            if (examTest && (this.state.application?.admissionTest ?? false)) {
                this.props.navigate('/addExam');
            } else if (registration) {
                this.props.navigate('/addRegistration');
            } else {
                this.props.navigate('/confirm-enrollment');
            }
            // this.state.application?.examTest ? this.props.navigate('/addExam') : this.props.navigate('/addRegistration')
        } else {
            !this.state.isEdit ? this.props.navigate('/admission-application') : this.setState({ isEdit: false }, () => this.props.onHandleClose());
        }
    };

    onChangeClass = (classId) => {
        const { classes } = this.state
        let selectedClassId = classes.find(el => el.classId === classId)
        let groupId = selectedClassId?.groups[0]?.groupId
        let selectedGradeName = selectedClassId?.className
        let groupName = selectedClassId?.groups[0]?.groupName
        this.setState({
            groupId: groupId,
            selectedGradeName: selectedGradeName,
        })
    }

    onSubmitApplication = async (isContinue) => {
        // Re-check application fee status before submission (but not if it causes button visibility issues)
        // Skip fee check during validation to prevent button disappearing
        // if (this.state.application?._id) {
        //     await this.checkApplicationFeePaidStatus();
        // }

        // testing purpose  
        // isContinue = true

        const formStatus = isFormValid(createApplicationFields, this.formFields.formValidations, trimObj(this.state.application));
        let isCompleteFormValid = true;
        if (!formStatus.formValidations.isFormValid) {
            // Preserve button-related states during validation errors
            const preservedStates = {
                isApplicationFeePaid: this.state.isApplicationFeePaid,
                isEdit: this.state.isEdit,
                isShowPayFeeButton: this.state.isShowPayFeeButton
            };

            this.setState({
                formValidations: formStatus.formValidations,
                isLoading: false,
                ...preservedStates // Preserve button states
            });
            this.toast.show({ severity: 'error', summary: 'Validation Error', detail: 'Please fill all required fields correctly', life: 3000 });
            return;
        }
        // dtesting purpose
        // isCompleteFormValid = true;


        if (!this.state.application?.govtIdType || !this.state.application?.idDetails) {
            // Preserve button-related states during validation errors
            const preservedStates = {
                isApplicationFeePaid: this.state.isApplicationFeePaid,
                isEdit: this.state.isEdit,
                isShowPayFeeButton: this.state.isShowPayFeeButton
            };

            this.setState({
                isLoading: false,
                ...preservedStates
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'Government ID Type and Government ID are required', life: 3000 });
            return
        }

        // Validate transport required fields
        if (this.state.application?.transportRequired && (!this.state.application?.requestedStop || this.state.application?.requestedStop?.trim() === "")) {
            const preservedStates = {
                isApplicationFeePaid: this.state.isApplicationFeePaid,
                isEdit: this.state.isEdit,
                isShowPayFeeButton: this.state.isShowPayFeeButton
            };

            this.setState({
                isLoading: false,
                ...preservedStates
            });
            this.toast.show({ severity: 'error', summary: 'Requested Stop Required', detail: 'Please enter the requested stop when transport is required', life: 3000 });
            return
        }

        // Check parent qualification and occupation from the correct data structure
        const firstParent = this.state.parents?.[0];
        const hasParentQualification = firstParent?.qualification || firstParent?.parentQualification || this.state.application?.qualification;
        const hasParentOccupation = firstParent?.profession || firstParent?.occupation || this.state.application?.profession;

        if (!hasParentQualification || !hasParentOccupation) {
            // Preserve button-related states during validation errors
            const preservedStates = {
                isApplicationFeePaid: this.state.isApplicationFeePaid,
                isEdit: this.state.isEdit,
                isShowPayFeeButton: this.state.isShowPayFeeButton
            };

            this.setState({
                isLoading: false,
                ...preservedStates
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'Parent Qualification and Occupation are required', life: 3000 });
            return
        }

        const { examTest, registration, enrollment } = this.state?.admissionSettingsInfo || {};
        let applicationData = { ...this.state.application }
        if (isCompleteFormValid) {
            let payload = {};
            payload = applicationData;
            payload.applicationId = this.state.application?.applicationId;


            payload._id = this.state.application?._id;
            payload.orgId = this.state.application?.orgId;
            payload.academicSession = this.state.application?.academicSession;

            payload.currentLocation = this.state.application?.currentLocation;
            // Only set stage to Application if student is not already enrolled
            if (this.state.application?.stage !== "Confirmed") {
                payload.stage = 'Application';
            }
            // payload.houseNum = this.state.application?.houseNum;
            // payload.streetOrVillage = this.state.application?.streetOrVillage;
            // payload.mandal = this.state.application?.mandal;
            payload.pinCode = this.state.application?.pinCode;
            payload.state = this.state.application?.state;
            payload.cityOrDist = this.state.application?.cityOrDist;


            payload.branchName = this.state.selectedbranchName;
            payload.boardName = this.state.selectedBoardName;
            payload.gradeName = this.state.selectedGradeName;

            payload.board = this.state.application?.board;
            payload.grade = this.state.application?.grade;
            payload.studentPhoto = this.state.application?.studentPhoto;

            // Include government ID details
            payload.govtIdType = this.state.application?.govtIdType;
            payload.idDetails = this.state.application?.idDetails;

            // Map parentQualification and occupation to qualification and profession for each parent
            const { parents, siblings } = this.state;
            payload.parents = parents.map(parent => ({
                ...parent,
                qualification: parent.parentQualification || parent.qualification || '',
                profession: parent.occupation || parent.profession || '',
                parentQualification: parent.parentQualification || parent.qualification || '',
                occupation: parent.occupation || parent.profession || '',
            }));
            payload.siblings = siblings;

            // Also set parentQualification and occupation at root for first parent (for backward compatibility)
            if (payload.parents && payload.parents.length > 0) {
                payload.parentQualification = payload.parents[0].parentQualification || payload.parents[0].qualification || '';
                payload.occupation = payload.parents[0].occupation || payload.parents[0].profession || '';
            }

            // dtest
            // payload.applicationData = this.state.application || {};

            payload.admissionTest = this.state.application?.admissionTest || false;
            if (this.state.isEdit == true) {
                payload.isEdit = true;
            }
            if (examTest && payload.admissionTest && isContinue) {
                // if (examTest && payload.admissionTest) {
                payload.stage = 'Exam';
            } else if (registration && isContinue) {
                payload.stage = 'Registration';
                payload.registration = {
                    siblings: [{ name: '', gender: '', classStudying: '', schoolStudying: '' }],
                    prevAcademicDetails: [{ name: '', classStudied: '', schoolStudied: '', percentageOrGpa: '' }]
                };
            } else if (enrollment && isContinue) {
                payload.stage = 'Enrollment';
            }

            this.setState({
                isLoading: true
            });

            // Check if application fee is enabled and not paid
            if (this.state.isShowPayFeeButton && !this.state.isApplicationFeePaid) {
                // Only require fee payment for new applications, not for updates or edits
                if (!this.state.isEdit && !this.state.application?._id) {
                    const preservedStates = {
                        isApplicationFeePaid: this.state.isApplicationFeePaid,
                        isEdit: this.state.isEdit,
                        isShowPayFeeButton: this.state.isShowPayFeeButton
                    };

                    this.setState({
                        isLoading: false,
                        ...preservedStates
                    });
                    this.toast.show({ severity: 'error', summary: 'Please Pay Application Fee', detail: 'Please Pay Application Fee', life: 3000 });
                    return;
                }

                // Block continuing to next step if fee is not paid
                if (isContinue) {
                    const preservedStates = {
                        isApplicationFeePaid: this.state.isApplicationFeePaid,
                        isEdit: this.state.isEdit,
                        isShowPayFeeButton: this.state.isShowPayFeeButton
                    };

                    this.setState({
                        isLoading: false,
                        ...preservedStates
                    });
                    this.toast.show({ severity: 'error', summary: 'Please Pay Application Fee', detail: 'Please pay the application fee before proceeding to next step', life: 3000 });
                    return;
                }
            }
            // if (!this.state?.application?.studentPhoto) {
            //     this.setState({
            //         isLoading: false
            //     });
            //     this.toast.show({ severity: 'error', summary: 'Please upload student photo', detail: 'Please upload student photo', life: 3000 });
            //     return;
            // }
            const url = `${baseUrlAdmin}/admissions/add-application`;
            this.service
                .post(url, payload, true)
                .then((res) => {
                    if (res && res.status && res.res.status) {
                        this.setState(
                            {
                                isLoading: false,
                                createdId: res?.res?.data
                            },
                            () => {
                                this.onHandleNavigate(isContinue);
                            }
                        );
                        this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                    }
                })
                .catch((e) => {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
                });
        }
    };

    deleteDifferentialFee = (index) => {
        const updatedFeeTypes = this.state.transportFeeTypes.filter((_, i) => i !== index);
        this.setState({ transportFeeTypes: updatedFeeTypes });
    };

    handleInputChange = (index, field, value) => {
        const feeType = [...this.state.transportFeeTypes];
        feeType[index][field] = value;
        this.setState({ feeType });
    };

    handleRadioButtonChange = (option) => {
        this.setState({ pickupFee: option });
    };
    openDailogPayAppFee = () => {
        let paymentMode = paymentModes.filter((e) => e.value !== '1c98862e-46dc-4454-a120-7d15e2e56e2f' && e.value !== '9d08ebab-2d3e-4a30-8460-4e4092fe30a1');
        this.setState({ isOpenPayFeeDailog: true, paymentModes: paymentMode });
    };

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];

        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    onChangeBranch = (branchId) => {
        this.setState({
            boards: [],
            classes: []
        });

        let selectedbranchName = this.props.branchData?.find((branchd) => branchd.key == branchId)?.name;
        let filteredBoards = this.props.boards.filter((board) => board.assignedBranches.includes(branchId));
        // Remove duplicates
        filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');

        this.setState({
            branchId: branchId,
            selectedbranchName: selectedbranchName,
            boards: filteredBoards,
            classes: [],
            boardId: '',
            selectedBoardName: '',
            classId: '',
            selectedClass: {},
            branches: [],
            selectedClassName: ''
        });
    };

    onChangeBoard = (boardId) => {
        this.setState({
            classes: [],
            sections: []
        });
        const selectedBoard = this.state.boards && this.props.boards.find((board) => board.boardId === boardId);

        this.setState({
            classes: selectedBoard?.classes || [],
            selectedClassesList: selectedBoard?.classes || [],
            boardId,
            selectedBoardName: selectedBoard?.boardName,
            classId: '',
            selectedClass: {},
            branches: [],
            selectedClassName: ''
        }, () => {
            // If DOB is already entered and age criteria is enabled, filter classes
            if (this.state.dob && this.state.admissionSettingsInfo?.ageCriteria && this.state.application?.branch) {
                this.getAgeCriteriaInfo(
                    this.state.application.branch,
                    boardId,
                    selectedBoard?.classes || []
                );
            }
        });
    };

    // Handle state selection and filter districts
    onStateChange = (selectedState) => {
        // Get districts for selected state from districts.json
        const stateDistricts = districts[selectedState] || [];

        // Transform districts to dropdown format
        let transformedDistricts = stateDistricts.map(district => ({
            label: district,
            value: district
        }));

        // If no districts found for the selected state, add "Other" option
        if (transformedDistricts.length === 0) {
            transformedDistricts = [{ label: 'Other', value: 'Other' }];
        }

        // Update state with filtered districts and reset city/district selection
        this.setState(prevState => ({
            cityOrDist: transformedDistricts,
            application: {
                ...prevState.application,
                state: selectedState,
                cityOrDist: '' // Reset district selection when state changes
            }
        }), () => {
            // Call the standard form validation after state update
            onDropDownChange(
                selectedState,
                'state',
                this,
                formFields,
                this.state.application,
                this.state.formValidations,
                'application',
                'formValidations'
            );
        });
    };

    onHandleCancelPayFee = () => {
        this.setState({
            isOpenPayFeeDailog: false,
            payFeeFormData: {},
            transctionId: null
        });
    };

    onCheckFeePaidInfo = async (isContinue) => {
        const url = `${baseUrlAdmin}/admissions/feePaidInfo?_id=${this.state.application?._id}`;
        this.service
            .get(url, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    const receiptInfo = res.res.data;

                    // Update applicationId if available in response
                    if (receiptInfo.applicationId && !this.state.application.applicationId) {
                        this.setState(prevState => ({
                            application: {
                                ...prevState.application,
                                applicationId: receiptInfo.applicationId
                            }
                        }));
                        localStorage.setItem('applicationId', receiptInfo.applicationId);
                    }

                    this.setState(
                        {
                            isLoading: false,
                            receiptInfo: res?.res?.data
                        },
                        () => {
                            this.handleShowReceipt(isContinue);
                        }
                    );
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred while fetching receipt info', life: 3000 });
            });
    };

    handleShowReceipt = (isContinue) => {
        const { receiptInfo } = this.state;
        console.log("📄 handleShowReceipt called with isContinue:", isContinue, "receiptInfo:", receiptInfo);

        if (!isContinue) {
            this.setState({
                isApplicationFeePaid: receiptInfo?.isApplicationFeePaid || false
            });
        } else {
            // Handle two cases:
            // 1. receiptInfo from payment verification (flat structure with receiptNo at root)
            // 2. receiptInfo from feePaidInfo (nested structure with application.receiptNo)

            const stageData = receiptInfo?.application || receiptInfo?.exam || receiptInfo?.registration || receiptInfo?.enrollment || receiptInfo;

            // Extract date - handle both ISO string and MongoDB $date object
            let receiptDate = stageData?.date || receiptInfo?.date;
            if (receiptDate && receiptDate.$date) {
                receiptDate = receiptDate.$date; // Extract from MongoDB format
            }

            let receiptData = {
                receiptName: stageData?.FeeTypeName || receiptInfo?.FeeTypeName || this.state.feePayInfo?.label || 'Application Fee',
                receiptNo: stageData?.receiptNo || receiptInfo?.receiptNo,
                receiptDate: receiptDate,
                studentName: stageData?.studentName || receiptInfo?.studentName || `${this.state.application?.firstName || ''} ${this.state.application?.lastName || ''}`.trim(),
                academicYear: stageData?.academicYearCode || receiptInfo?.academicYearCode || this.state.application?.academicSession || this.state.application?.academicYearCode,
                className: stageData?.gradeName || receiptInfo?.gradeName || this.state.application?.gradeName,
                paymentMode: stageData?.paymentMode || receiptInfo?.paymentMode || 'Online',
                // CRITICAL: Use transactionId (actual payment gateway ID), NOT orderId
                transactionId: stageData?.transactionId || stageData?.transctionId || receiptInfo?.transactionId || this.state.transctionId,

                feePaidDetails: [
                    {
                        feeType: stageData?.FeeTypeName || receiptInfo?.FeeTypeName || this.state.feePayInfo?.feeName || 'Application Fee',
                        amountPaying: Number(stageData?.feeAmount || receiptInfo?.feeAmount || receiptInfo?.amount || this.state.feePayInfo?.amount || 0),
                        fineAmtPaying: 0,
                        gstPaidNow: 0
                    }
                ],
                amountPaid: Number(stageData?.feeAmount || receiptInfo?.feeAmount || receiptInfo?.amount || this.state.feePayInfo?.amount || 0)
            };

            console.log('📄 Application Receipt Data:', {
                stageData: stageData,
                transactionId: receiptData.transactionId,
                amountPaid: receiptData.amountPaid,
                orderId: stageData?.orderId,
                source: receiptInfo?.application ? 'AdmissionFee document (nested)' : 'Payment verification (flat)'
            });

            this.setState({
                isShowReceipt: true,
                receiptInfo: receiptData,
                isApplicationFeePaid: receiptInfo?.isApplicationFeePaid || false,
                isPaymentJustCompleted: false // Reset the flag after showing receipt
            });
        }

        if (!this.state.isShowPayFeeButton) {
            this.setState({
                isApplicationFeePaid: true
            });
        }
    };

    OnPayFee = () => {
        this.setState({ isLoading: false });
        let academicYear = localStorage.getItem('userAcademicYear');
        let data = this.state.payFeeFormData;
        this.setState({ isLoading: true });
        let url = `${baseUrlAdmin}/admissions/payFee`;
        let paymentMode = this.state.paymentModes.find((el) => el.value == data?.paymentType)?.label;
        data.paymentMode = paymentMode;
        data.FeeTypeName = this.state.feePayInfo?.feeName;
        data.feeAmount = Number(this.state.feePayInfo?.amount);
        data.transctionId = this.state?.transctionId;
        if (
            data?.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' ||
            data?.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
            data?.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f' ||
            data?.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
        ) {
            if (!data?.transctionId) {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Please enter transaction id.', detail: 'Please enter transaction id.', life: 3000 });
                return;
            }
        } else {
            data.transctionId = null;
        }
        const formStatus = isFormValid(createFields, this.payformFields.formValidations, trimObj(data));
        let isCompleteFormValid = true;
        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                payFormValidations: formStatus.formValidations
            });
            isCompleteFormValid = false;
        }
        let payload = { ...data, academicSession: academicYear };
        if (this.state?.application?._id) {
            payload.academicYearCode = this.state.application?.enquiry?.academicYearCode;
            payload.admissionCategoryName = this.state.application?.enquiry?.admissionCategoryName;
            payload.studentName = `${this.state?.application?.firstName} ${this.state?.application?.lastName}`;
            payload.applicationNo = this.state?.application?.applicationId;
            payload.admissionId = this.state?.application?._id;
            payload.academicYear = this.state?.application?.academicSession;
            payload.gradeName = this.state.application?.gradeName;
            // Only set stage to Application if student is not already enrolled
            if (this.state.application?.stage !== "Confirmed") {
                payload.stage = 'Application';
            }
        }
        if (isCompleteFormValid) {
            this.service
                .post(url, payload, true)
                .then((res) => {
                    if (res && res.status && res.res.status) {
                        if (res.res.data) {
                            // **NEW: Extract and store the applicationId after successful payment**
                            const responseData = res.res.data;
                            const generatedApplicationId = responseData.applicationId ||
                                responseData.applicationNo;

                            if (generatedApplicationId) {
                                console.log("Generated Application ID:", generatedApplicationId);

                                // Update the application state
                                this.setState(prevState => ({
                                    application: {
                                        ...prevState.application,
                                        applicationId: generatedApplicationId
                                    },
                                    createdId: responseData._id || responseData.admissionId
                                }));

                                // Store in localStorage
                                localStorage.setItem('applicationId', generatedApplicationId);
                            }
                            // Prepare receipt data from local state as fallback
                            const localReceiptData = {
                                receiptName: this.state.feePayInfo?.feeName || 'Application Fee',
                                receiptNo: responseData.receiptNo || `REC-${Date.now()}`,
                                receiptDate: new Date().toISOString(),
                                studentName: `${this.state.application?.firstName || ''} ${this.state.application?.lastName || ''}`.trim(),
                                academicYear: this.state.application?.academicSession,
                                className: this.state.application?.gradeName,
                                paymentMode: this.state.paymentModes.find((el) => el.value === data?.paymentType)?.label || 'Online',
                                transactionId: data.transctionId,
                                feePaidDetails: [
                                    {
                                        feeType: this.state.feePayInfo?.feeName || 'Application Fee',
                                        amountPaying: Number(this.state.feePayInfo?.amount || 0),
                                        fineAmtPaying: 0,
                                        gstPaidNow: 0
                                    }
                                ],
                                amountPaid: Number(this.state.feePayInfo?.amount || 0)
                            };

                            this.setState(
                                {
                                    isOpenPayFeeDailog: false,
                                    isLoading: false,
                                    payFeeFormData: {},
                                    transctionId: null,
                                    isApplicationFeePaid: true,
                                    // Set local receipt data as fallback
                                    receiptInfo: localReceiptData,
                                    isShowReceipt: true,
                                    isPaymentJustCompleted: true // Flag that payment was just completed

                                },
                                async () => {
                                    // After payment is successful, show success message
                                    this.toast.show({
                                        severity: 'success',
                                        summary: 'Success',
                                        detail: 'Application fee paid successfully. You can now submit the application.',
                                        life: 3000
                                    });

                                    // Fetch updated receipt info from server and display it
                                    try {
                                        await this.onCheckFeePaidInfo(true); // Pass true to trigger receipt display
                                    } catch (error) {
                                        console.warn('Could not fetch updated receipt info, showing local data:', error);
                                        // Receipt is already set with local data, so display it
                                        this.setState({ isShowReceipt: true });
                                    }
                                }
                            );
                            this.toast.show({
                                severity: 'success',
                                summary: 'Success',
                                detail: 'Application fee paid successfully. Application ID generated.',
                                life: 3000
                            });
                            this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });
                        } else {
                            this.setState({
                                isLoading: false
                            });
                            this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                        }
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res?.errMessage, life: 3000 });
                    }
                })
                .catch((e) => {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
                });
        } else {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Please fill all the required fields.', detail: 'Please fill all the required fields.', life: 3000 });
        }
    };


    // ////////////PG SDK or Script loading////////
    loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    // loadCashfreeSDK = () => {
    // }

    /**
 * Handle NTT Data payment initiation
 */
    handleNTTDataPayment = () => {
        const { payFeeFormData, application, feePayInfo, parents, siblings } = this.state;

        // Save complete application state before payment redirect
        const applicationStateToSave = {
            application: application,
            parents: parents,
            siblings: siblings,
            feePayInfo: feePayInfo,
            // Save dropdown arrays to restore after payment
            boards: this.state.boards,
            classes: this.state.classes,
            cityOrDist: this.state.cityOrDist,
            branchId: this.state.branchId,
            boardId: this.state.boardId,
            classId: this.state.classId,
            // Save display names for Board, Grade, Branch, City/District
            selectedbranchName: this.state.selectedbranchName,
            selectedBoardName: this.state.selectedBoardName,
            selectedGradeName: this.state.selectedGradeName,
            selectedClassName: this.state.selectedClassName,
            timestamp: Date.now()
        };

        console.log('💾 Saving application state before payment:', {
            board: application?.board,
            grade: application?.grade,
            branchId: this.state.branchId,
            boardId: this.state.boardId,
            classId: this.state.classId,
            selectedBoardName: this.state.selectedBoardName,
            selectedGradeName: this.state.selectedGradeName,
            boardsCount: this.state.boards?.length,
            classesCount: this.state.classes?.length
        });

        sessionStorage.setItem('pendingApplicationPayment', JSON.stringify(applicationStateToSave));
        sessionStorage.setItem('applicationId', application?._id);
        sessionStorage.setItem('referenceNo', application?.referenceNo);

        // Prepare payment data for NTT component
        const paymentData = {
            amount: this.state.partialPayment
                ? payFeeFormData?.amountPaying
                : (feePayInfo?.amount || payFeeFormData?.dueAmount),
            studentId: application?._id,
            installmentId: payFeeFormData?.installmentId,
            feeType: feePayInfo?.feeName || payFeeFormData?.feeinstallmentTitle || 'Application Fee',
            studentName: application?.firstName && application?.lastName
                ? `${application.firstName} ${application.lastName}`.trim()
                : application?.firstName || 'Student',
            studentEmail: application?.emailId || application?.parentEmailId || 'student@classet.com',
            studentPhone: application?.parentContact || application?.contactNo || '9999999999',
            branchId: application?.branch,
            boardId: application?.board,
            classId: application?.grade,
            sectionId: application?.section,
            orgId: localStorage.getItem('orgId'),
            feeFor: 'Admissions',
            feeType: 'Application',
            referenceNo: application?.referenceNo,
            pathName: application?.referenceNo ? `/application?referenceNo=${application.referenceNo}` : '/application', // Preserve form context with referenceNo in URL
            // Add missing fields for receipt
            boardName: application?.boardName || '',
            gradeName: application?.gradeName || '',
            branchName: application?.branchName || '',
            cityOrDist: application?.cityOrDist || '',
            academicYearCode: application?.academicYearCode || '',
            admissionCategoryName: application?.admissionCategoryName || 'General'
        };
        console.log('Initiating NTT Data payment with data:+++++++++++++', paymentData);

        this.setState({
            showNTTPayment: true,
            nttPaymentData: paymentData
        });
    };

    /**
     * Handle successful NTT payment
     */
    onNTTPaymentSuccess = (paymentResult) => {
        console.log('NTT Payment successful:', paymentResult);

        // Update transaction ID and close payment dialog
        this.setState({
            transctionId: paymentResult.transactionId || paymentResult.payment_id,
            showNTTPayment: false,
            nttPaymentData: null
        }, () => {
            // Process the fee payment on backend
            this.OnPayFee();
        });
    };

    /**
     * Handle NTT payment error
     */
    onNTTPaymentError = (error) => {
        console.error('NTT Payment error:', error);

        this.setState({
            showNTTPayment: false,
            nttPaymentData: null
        });

        if (this.toast) {
            this.toast.show({
                severity: 'error',
                summary: 'Payment Error',
                detail: error.message || 'Payment failed. Please try again.',
                life: 5000
            });
        }
    };

    /**
     * Handle NTT payment cancellation
     */
    onNTTPaymentCancel = () => {
        console.log('NTT Payment cancelled');

        this.setState({
            showNTTPayment: false,
            nttPaymentData: null
        });

        if (this.toast) {
            this.toast.show({
                severity: 'warn',
                summary: 'Payment Cancelled',
                detail: 'Payment was cancelled by user',
                life: 3000
            });
        }
    };

    /**
     * Handle payment redirect after gateway returns
     */
    handlePaymentRedirect = async (status, txnId, atomTxnId, referenceNo) => {
        console.log('🔍 Payment redirect detected:', { status, txnId, atomTxnId, referenceNo });

        // Restore application state from sessionStorage
        const savedState = sessionStorage.getItem('pendingApplicationPayment');
        console.log('📦 SessionStorage check:', savedState ? '✅ Found savedState' : '❌ No savedState found');

        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState);
                console.log('📋 Successfully parsed state. Student:', parsedState.application?.studentName,
                    '| Parents:', parsedState.parents?.length,
                    '| Siblings:', parsedState.siblings?.length);

                const savedApplicationId = sessionStorage.getItem('applicationId');
                const savedReferenceNo = sessionStorage.getItem('referenceNo');
                console.log('🆔 Application ID:', savedApplicationId, '| Reference No:', savedReferenceNo);

                // Check if saved state is not too old (30 minutes)
                if (Date.now() - parsedState.timestamp < 30 * 60 * 1000) {
                    console.log('✅ Saved state is fresh (< 30 min old)');

                    if (status === 'success') {
                        // Payment successful
                        this.setState({
                            isLoading: true
                        });

                        // Verify payment status from backend
                        try {
                            const verifyUrl = `${baseUrlAdmin}/admissions/verify-admission-payment`;
                            const verifyResponse = await this.service.post(verifyUrl, {
                                txnId: txnId, // merchTxnId (order_id) - guaranteed to exist
                                atomTxnId: atomTxnId, // May not exist yet if callback hasn't arrived
                                admissionId: savedApplicationId,
                                referenceNo: savedReferenceNo || referenceNo
                            }, true);

                            if (verifyResponse?.res?.status) {
                                // Payment verified successfully
                                const paymentData = verifyResponse.res.data;
                                console.log('✅ Payment verification successful:', paymentData);

                                console.log('📥 Restoring application state after payment:', {
                                    board: parsedState.application?.board,
                                    grade: parsedState.application?.grade,
                                    branchId: parsedState.branchId,
                                    boardId: parsedState.boardId,
                                    classId: parsedState.classId,
                                    boardsCount: parsedState.boards?.length,
                                    classesCount: parsedState.classes?.length
                                });

                                // Restore application state with ALL saved data including dropdown arrays
                                console.log('🔄 Restoring state to component...');
                                this.setState({
                                    application: {
                                        ...parsedState.application,
                                        applicationId: paymentData.applicationId || parsedState.application.applicationId,
                                        applicationFeePaid: true,
                                        referenceNo: paymentData.referenceNo || parsedState.application.referenceNo
                                    },
                                    parents: parsedState.parents || [],
                                    siblings: parsedState.siblings || [],
                                    boards: parsedState.boards || this.state.boards,
                                    classes: parsedState.classes || this.state.classes,
                                    cityOrDist: parsedState.cityOrDist || this.state.cityOrDist,
                                    branchId: parsedState.branchId || this.state.branchId,
                                    boardId: parsedState.boardId || this.state.boardId,
                                    classId: parsedState.classId || this.state.classId,
                                    // Restore display names for Board, Grade, Branch, City/District
                                    selectedbranchName: parsedState.selectedbranchName || this.state.selectedbranchName,
                                    selectedBoardName: parsedState.selectedBoardName || this.state.selectedBoardName,
                                    selectedGradeName: parsedState.selectedGradeName || this.state.selectedGradeName,
                                    selectedClassName: parsedState.selectedClassName || this.state.selectedClassName,
                                    isApplicationFeePaid: true,
                                    isLoading: false,
                                    isPaymentJustCompleted: true,
                                    receiptInfo: paymentData.receipt || null
                                }, () => {
                                    console.log('✅ State restored successfully:', {
                                        applicationBoard: this.state.application?.board,
                                        applicationGrade: this.state.application?.grade,
                                        boardsCount: this.state.boards?.length,
                                        classesCount: this.state.classes?.length
                                    });

                                    // DON'T call onChangeBranch/onChangeBoard as they clear the selected values
                                    // The boards and classes arrays are already restored from savedState
                                    // Just ensure the application.board and application.grade values are set
                                    if (parsedState.application?.board || parsedState.boardId) {
                                        this.setState(prevState => ({
                                            application: {
                                                ...prevState.application,
                                                board: parsedState.application?.board || parsedState.boardId,
                                                grade: parsedState.application?.grade || parsedState.classId
                                            }
                                        }));
                                    }

                                    // Format and show receipt using handleShowReceipt
                                    if (paymentData.receipt) {
                                        console.log('📄 Showing receipt...');
                                        this.handleShowReceipt(true);
                                    }
                                });

                                // Show success message with confirmation
                                this.toast.show({
                                    severity: 'success',
                                    summary: '✅ Payment Successful',
                                    detail: `Application fee paid successfully! Transaction ID: ${txnId}${paymentData.applicationId ? '. Application ID: ' + paymentData.applicationId : ''}`,
                                    life: 8000,
                                    sticky: false
                                });

                                // Clear session storage
                                sessionStorage.removeItem('pendingApplicationPayment');
                                sessionStorage.removeItem('applicationId');
                                sessionStorage.removeItem('referenceNo');

                                // Clean URL without query parameters (following exam.js pattern)
                                window.history.replaceState({}, document.title, '/application');
                            } else {
                                throw new Error(verifyResponse?.res?.message || 'Payment verification failed');
                            }
                        } catch (error) {
                            console.error('Payment verification error:', error);

                            // Restore form silently - verification may fail temporarily while callback is processing
                            this.setState({
                                application: parsedState.application,
                                parents: parsedState.parents || [],
                                siblings: parsedState.siblings || [],
                                isLoading: false
                            }, async () => {
                                await this.onChangeBranch(this.state.application?.branch);
                                await this.onChangeBoard(this.state.application?.board);
                            });

                            // Clear session storage and URL
                            sessionStorage.removeItem('pendingApplicationPayment');
                            sessionStorage.removeItem('applicationAdmissionId');
                            sessionStorage.removeItem('applicationReferenceNo');
                            window.history.replaceState({}, document.title, '/application');
                        }
                    } else if (status === 'failure') {
                        // Payment failed
                        this.setState({
                            application: parsedState.application,
                            parents: parsedState.parents || [],
                            siblings: parsedState.siblings || [],
                            isLoading: false
                        }, async () => {
                            await this.onChangeBranch(this.state.application?.branch);
                            await this.onChangeBoard(this.state.application?.board);
                        });

                        this.toast.show({
                            severity: 'error',
                            summary: '❌ Payment Failed',
                            detail: 'Payment was not completed. Please try again.',
                            life: 5000
                        });

                        // Clean URL - keep on form, not list
                        window.history.replaceState({}, document.title, '/application');
                    } else if (status === 'cancelled') {
                        // Payment cancelled
                        this.setState({
                            application: parsedState.application,
                            parents: parsedState.parents || [],
                            siblings: parsedState.siblings || [],
                            isLoading: false
                        }, async () => {
                            await this.onChangeBranch(this.state.application?.branch);
                            await this.onChangeBoard(this.state.application?.board);
                        });

                        this.toast.show({
                            severity: 'warn',
                            summary: 'Payment Cancelled',
                            detail: 'You cancelled the payment. You can retry payment anytime.',
                            life: 5000
                        });

                        // Clean URL - keep on form, not list
                        window.history.replaceState({}, document.title, '/application');
                    }
                } else {
                    // Session expired
                    this.toast.show({
                        severity: 'warn',
                        summary: 'Session Expired',
                        detail: 'Payment session expired. Please start again.',
                        life: 5000
                    });
                    sessionStorage.removeItem('pendingApplicationPayment');
                    sessionStorage.removeItem('applicationId');
                    sessionStorage.removeItem('referenceNo');
                }
            } catch (error) {
                console.error('❌ Error restoring application state:', error);
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to restore application data',
                    life: 5000
                });
            }
        } else {
            console.warn('⚠️ No savedState found in sessionStorage. Checking for direct link scenario...');

            // No saved state - might be a direct link or manual refresh
            if (status === 'success' && (referenceNo || txnId || atomTxnId)) {
                console.log('🔗 Direct link scenario detected. Loading data by payment params...');
                this.setState({ isLoading: true });

                this.toast.show({
                    severity: 'info',
                    summary: 'Loading Application',
                    detail: 'Payment completed. Loading your application...',
                    life: 3000
                });

                try {
                    // Try to verify payment and get admission details
                    const verifyUrl = `${baseUrlAdmin}/admissions/verify-admission-payment`;
                    const verifyResponse = await this.service.post(verifyUrl, {
                        txnId: txnId, // merchTxnId (order_id) - guaranteed to exist
                        atomTxnId: atomTxnId || txnId,
                        referenceNo: referenceNo
                    }, true);

                    if (verifyResponse?.res?.status) {
                        const paymentData = verifyResponse.res.data;

                        // Load application by referenceNo
                        if (paymentData.referenceNo) {
                            await this.getApplicationByReferenceNo(paymentData.referenceNo);

                            // Set receipt info and show receipt
                            this.setState({
                                receiptInfo: paymentData.receipt || null,
                                isApplicationFeePaid: true,
                                isPaymentJustCompleted: true
                            }, () => {
                                // Show receipt if available
                                if (paymentData.receipt) {
                                    this.handleShowReceipt(true);
                                }
                            });

                            this.toast.show({
                                severity: 'success',
                                summary: '✅ Payment Confirmed',
                                detail: `Payment successful! Transaction ID: ${paymentData.transactionId}`,
                                life: 5000
                            });

                            // Clean URL - keep on form, not list
                            window.history.replaceState({}, document.title, '/application');
                        }
                    }
                } catch (error) {
                    console.error('Error loading application after payment:', error);
                    this.setState({ isLoading: false });

                    this.toast.show({
                        severity: 'warn',
                        summary: 'Payment Completed',
                        detail: 'Payment was successful but could not load application. Please refresh the page.',
                        life: 5000
                    });
                }
            }
        }
    };

    handlePayment = async () => {
        let payType = this.state.payFeeFormData?.paymentType;
        let a = this.state.partialPayment ? this.state.payFeeFormData?.amountPaying : this.state.payFeeFormData?.dueAmount
        // let PGtype = 'cashfree'; // Default payment gateway type, can be changed based on user selection
        // let PGtype = 'ntt_data';
        let PGtype = process.env.REACT_APP_DEFAULT_PAYMENT_GATEWAY || 'ntt_data';



        if (payType) {

            if (
                payType === '74b95cc8-9736-44a0-b2df-325595783c3b' ||
                payType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' ||
                payType === "9d08ebab-2d3e-4a30-8460-4e4092fe30a1" ||
                payType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                payType === "274a4416-2454-4f3a-b741-89c67361ae1f"
            ) {
                this.OnPayFee()
            } else if (
                payType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' ||
                payType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
            ) {
                switch (PGtype) {
                    case 'razorpay': {
                        const res = await this.loadRazorpayScript();
                        if (!res) {
                            alert("Failed to load Razorpay SDK. Check your internet connection.");
                            return;
                        }
                        let url = `${baseUrlAdmin}/create-order`;
                        let vurl = `${baseUrlAdmin}/verify-payment`;

                        let payload = {
                            amount: this.state.partialPayment ? this.state.payFeeFormData?.amountPaying * 100 : this.state.payFeeFormData?.dueAmount * 100,
                            currency: "INR"
                        }
                        // Get order details from your backend
                        const { data: order } = await Axios.post(url, payload);

                        const options = {
                            key: "rzp_test_rJgczs9D0fmDjk", // Replace with your Razorpay key
                            amount: order.amount,
                            currency: order.currency,
                            name: "Classet",
                            description: "Purchase Description",
                            image: `https://${profilesBucket}.s3.${awsRegion}.amazonaws.com/uploads/17358829538761712311939159IMG-20231127-WA0017%20-%20Copy.jpg`,
                            order_id: order.id,
                            handler: async (response) => {
                                const result = await Axios.post(vurl, {
                                    order_id: order.id,
                                    razorpay_payment_id: response.razorpay_payment_id,
                                    razorpay_signature: response.razorpay_signature,
                                });
                                this.setState({
                                    transctionId: response.razorpay_payment_id
                                }, () => {
                                    this.OnPayFee();
                                })
                            },


                            prefill: {
                                name: "Monangi Kiran",
                                email: "kiranm@classet.in",
                                contact: "7799279701",
                            },
                            theme: {
                                color: "#3399cc",
                            },
                        };

                        const paymentObject = new window.Razorpay(options);
                        console.log("RAZOR", paymentObject)
                        paymentObject.open();
                    }; break;
                    case 'cashfree': {
                        let parentContactNumer;
                        if (this.state.searchLevel === 2) {
                            parentContactNumer = this.state?.dropdownsData?.parentContactNumber[0];
                        }

                        const url = `${baseUrlAdmin}/cashfree/create-order`;
                        const payload = {

                            platform: 'web',
                            academicYear: localStorage.getItem('userAcademicYear'),
                            orgId: localStorage.getItem('orgId'),

                            order_amount: this.state.partialPayment
                                ? this.state.payFeeFormData?.amountPaying
                                : this.state.feePayInfo?.amount,
                            order_currency: "INR",
                            order_id: "order_" + uuidv4(), // Generate a unique order ID using uuid
                            customer_details: {
                                customer_name: this.state?.application?.firstName && this.state?.application?.lastName
                                    ? `${this.state.application.firstName} ${this.state.application.lastName}`.trim()
                                    : `${this.state?.application?.firstName}`,
                                customer_id: this.state?.application?._id,
                                customer_email: this.state?.application?.parentEmailId || 'classet@123@gmail.com',
                                customer_phone: this.state?.application?.parentContact || this.state?.application?.contactNo || '9999999999',
                            },
                            order_meta: {
                                return_url: null,
                            },
                        };

                        this.setState({ isLoading: true });

                        // Try asymmetric encryption first, fallback to symmetric, then unencrypted
                        const encryptPayload = async (payload) => {
                            try {
                                // Use only asymmetric (hybrid) encryption for strong security
                                console.log('🔐 Attempting hybrid encryption for Cashfree order creation...');
                                const hybridEncrypted = await asymmetricEncryptionUtils.prepareEncryptedPayload(payload);

                                if (hybridEncrypted.hybridEncrypted) {
                                    console.log('✅ Hybrid encryption successful for order creation');
                                    return hybridEncrypted;
                                }

                                // If encryption fails, throw error instead of sending unencrypted data
                                throw new Error('Hybrid encryption failed');

                            } catch (error) {
                                console.error('❌ Payment encryption failed:', error);
                                throw new Error('Payment encryption failed. Please try again.');
                            }
                        };

                        encryptPayload(payload)
                            .then((encryptedPayload) => {
                                return this.service.post(url, encryptedPayload, true);
                            })
                            .then(async (response) => {
                                this.setState({ isLoading: false });

                                console.log('🔍 Raw Cashfree order creation response:', response);

                                // Decrypt the response if it's encrypted
                                let decryptedResponse = response;

                                // Check if response needs decryption
                                if (response?.res?.encrypted || response?.res?.hybridEncrypted) {
                                    try {
                                        console.log('🔓 Decrypting Cashfree order creation response...');
                                        console.log('🔍 Response structure before decryption:', {
                                            hasRes: !!response.res,
                                            encrypted: response.res?.encrypted,
                                            hybridEncrypted: response.res?.hybridEncrypted,
                                            keys: Object.keys(response.res || {})
                                        });

                                        // Decrypt using asymmetric encryption utils
                                        const decryptedData = await asymmetricEncryptionUtils.decryptResponse(response.res);

                                        console.log('✅ Order creation response decrypted successfully');
                                        console.log('🔍 Decrypted data structure:', {
                                            hasStatus: !!decryptedData.status,
                                            hasData: !!decryptedData.data,
                                            dataKeys: Object.keys(decryptedData.data || {}),
                                            hasPaymentSessionId: !!decryptedData.data?.payment_session_id
                                        });

                                        decryptedResponse = {
                                            ...response,
                                            res: decryptedData
                                        };

                                        // Also create direct data access for backward compatibility
                                        decryptedResponse.data = decryptedData.data;
                                        decryptedResponse.status = decryptedData.status;

                                    } catch (decryptError) {
                                        console.error('❌ Error decrypting order creation response:', decryptError);
                                        console.warn('⚠️ Using original response due to decryption error');
                                        // Continue with original response as fallback
                                    }
                                } else {
                                    console.log('✅ Response is not encrypted, using as-is');
                                    // For unencrypted responses, ensure proper structure
                                    if (response.res) {
                                        decryptedResponse.data = response.res.data;
                                        decryptedResponse.status = response.res.status;
                                    }
                                }

                                console.log('🔍 Final decryptedResponse structure:', {
                                    hasStatus: !!decryptedResponse.status,
                                    hasData: !!decryptedResponse.data,
                                    hasResStatus: !!decryptedResponse.res?.status,
                                    hasResData: !!decryptedResponse.res?.data,
                                    dataKeys: Object.keys(decryptedResponse.data || {}),
                                    resDataKeys: Object.keys(decryptedResponse.res?.data || {})
                                });

                                // Check for payment_session_id in correct response structure
                                let paymentSessionId = null;
                                let foundInLocation = '';

                                // Primary locations - check decrypted response first
                                if (decryptedResponse.data?.payment_session_id) {
                                    paymentSessionId = decryptedResponse.data.payment_session_id;
                                    foundInLocation = 'decryptedResponse.data.payment_session_id';
                                } else if (decryptedResponse.res?.data?.payment_session_id) {
                                    paymentSessionId = decryptedResponse.res.data.payment_session_id;
                                    foundInLocation = 'decryptedResponse.res.data.payment_session_id';
                                } else if (decryptedResponse.data?.paymentSessionId) {
                                    paymentSessionId = decryptedResponse.data.paymentSessionId;
                                    foundInLocation = 'decryptedResponse.data.paymentSessionId';
                                } else if (decryptedResponse.res?.data?.paymentSessionId) {
                                    paymentSessionId = decryptedResponse.res.data.paymentSessionId;
                                    foundInLocation = 'decryptedResponse.res.data.paymentSessionId';
                                }

                                console.log('🔍 Payment session ID search results:', {
                                    paymentSessionId,
                                    foundInLocation,
                                    searchedLocations: [
                                        'decryptedResponse.data.payment_session_id',
                                        'decryptedResponse.res.data.payment_session_id',
                                        'decryptedResponse.data.paymentSessionId',
                                        'decryptedResponse.res.data.paymentSessionId'
                                    ]
                                });

                                if (decryptedResponse.status && paymentSessionId) {
                                    console.log('✅ Payment session ID found:', paymentSessionId, 'at location:', foundInLocation);

                                    //TO CREATE ORDER -> from order, paymentSessionId generated -> payments gets completed.
                                    // Open Cashfree checkout modal
                                    const checkoutOptions = {
                                        paymentSessionId: paymentSessionId,
                                        redirectTarget: "_modal",
                                    };
                                    const initializeCashfree = async () => {
                                        const { load } = await import('@cashfreepayments/cashfree-js');
                                        // const cashfree = await load({ mode: "sandbox" }); // Use "production" for live environment
                                        const cashfreeMode = process.env.REACT_APP_CASHFREE_MODE;
                                        const cashfree = await load({ mode: cashfreeMode });

                                        cashfree.checkout(checkoutOptions).then((result) => {
                                            if (result.error) {
                                                console.error("Payment error:", result.error);
                                            } else if (result.paymentDetails) {
                                                // console.log("===AFTER PAYMENT DETAILS===:", result);
                                                // console.log("Payment completed successfully:", result.paymentDetails);

                                                // store the payment details.
                                                sendPaymentSessionDetails()
                                                // console.log('PAYLOAD.ORDER_ID:', payload.order_id);
                                            }
                                        });
                                    };
                                    initializeCashfree();

                                    // Send and Store 
                                    const sendPaymentSessionDetails = async () => {
                                        // const isMobile = /Mobi|Android/i.test(navigator.userAgent); // Check if the user is on a mobile device
                                        const isDoneThrough = "Web-Admin"
                                        const loggedInUser = localStorage.getItem('username'); // Replace 'username' with the key used to store user info
                                        // console.log("**********Payment Details:*****************", paymentDetails);

                                        try {
                                            // Prepare the verify-and-collect payload
                                            const verifyCollectPayload = {
                                                platform: 'web',
                                                academicYear: localStorage.getItem('userAcademicYear'),
                                                orgId: localStorage.getItem('orgId'),

                                                orderId: payload.order_id, // Include order ID in the payload
                                                paymentSessionId: paymentSessionId, // Pass the session ID as payload
                                                paymentDetails: 'payment finished', // Include payment details


                                                // Application-specific fields from OnPayFee payload
                                                academicSession: localStorage.getItem('userAcademicYear'),
                                                academicYearCode: this.state.application?.enquiry?.academicYearCode,
                                                admissionCategoryName: this.state.application?.enquiry?.admissionCategoryName,
                                                studentName: `${this.state?.application?.firstName} ${this.state?.application?.lastName}`,
                                                applicationNo: this.state?.application?.applicationId,
                                                admissionId: this.state?.application?._id,
                                                gradeName: this.state.application?.gradeName,
                                                stage: 'Application',

                                                transactionId: this.state.transactionId || '', // Use the transaction ID from the state
                                                transctionId: this.state.transactionId || '', // Use the transaction ID from the state

                                                // Fee-related fields
                                                paymentMode: this.state.paymentModes?.find((el) => el.value == this.state.payFeeFormData?.paymentType)?.label || 'Online Payment',
                                                paymentType: this.state.payFeeFormData?.paymentType || 'Online',
                                                feeTypeName: this.state.feePayInfo?.feeName,
                                                feeAmount: Number(this.state.feePayInfo?.amount),

                                                // Contact information (using application data instead of user_info)
                                                branchId: this.state?.application?.branch,
                                                boardId: this.state?.application?.board,
                                                classId: this.state?.application?.grade,
                                                sectionId: this.state?.application?.sectionId,

                                                studentId: this.state?.application?._id,
                                                enrollmentNo: 'NA', // Not applicable for application stage
                                                feeTypeName: this.state.feePayInfo?.feeName || 'application fee',
                                                parentContactNumber: this.state?.application?.parentContact || this.state?.application?.contactNo,

                                                isDoneThrough: isDoneThrough, // Add the flag for web or mobile
                                                loggedInUser: loggedInUser, // Include the logged-in user information
                                            };

                                            // Encrypt verify-and-collect payload with asymmetric encryption only
                                            const encryptVerifyPayload = async (payload) => {
                                                try {
                                                    // Use only asymmetric (hybrid) encryption for strong security
                                                    console.log('🔐 Attempting hybrid encryption for verify-and-collect...');
                                                    const hybridEncrypted = await asymmetricEncryptionUtils.prepareEncryptedPayload(payload);

                                                    if (hybridEncrypted.hybridEncrypted) {
                                                        console.log('✅ Hybrid encryption successful for verify-and-collect');
                                                        return hybridEncrypted;
                                                    }

                                                    // If encryption fails, throw error instead of sending unencrypted data
                                                    throw new Error('Hybrid encryption failed for verify-and-collect');

                                                } catch (error) {
                                                    console.error('❌ Payment verification encryption failed:', error);
                                                    throw new Error('Payment verification encryption failed. Please try again.');
                                                }
                                            };

                                            const encryptedVerifyPayload = await encryptVerifyPayload(verifyCollectPayload);
                                            const response = await this.service.post(`${baseUrlAdmin}/cashfree/verifyAndCollectAdmissionFee`, encryptedVerifyPayload, true);

                                            // Decrypt the response if it's encrypted (asymmetric only)
                                            let decryptedVerifyResponse = response;

                                            if (response?.res?.encrypted || response?.res?.hybridEncrypted) {
                                                try {
                                                    console.log('🔓 Decrypting verify-and-collect response with asymmetric encryption...');

                                                    // Use only asymmetric decryption for strong security
                                                    let decryptedData = await asymmetricEncryptionUtils.decryptResponse(response.res);

                                                    decryptedVerifyResponse = {
                                                        ...response,
                                                        res: decryptedData
                                                    };

                                                    console.log('✅ Verify-and-collect response decrypted successfully with RSA + AES');
                                                } catch (decryptError) {
                                                    console.error('❌ Error decrypting verify-and-collect response:', decryptError);
                                                    // Continue with original response as fallback
                                                    console.warn('⚠️ Using original response due to decryption error');
                                                }
                                            }

                                            if (decryptedVerifyResponse?.res?.res?.data) {
                                                // Payment successful - handle receipt generation
                                                console.log(decryptedVerifyResponse?.res)
                                                console.log("Transaction ID from response:", decryptedVerifyResponse?.res?.transactionId);
                                                console.log("Transaction ID from response:", decryptedVerifyResponse?.res?.res?.transactionId);

                                                const receiptData = decryptedVerifyResponse.res.res.data;
                                                const paymentDetails = decryptedVerifyResponse.res.res.paymentDetails;

                                                // **NEW: Extract and store the applicationId**
                                                const generatedApplicationId = receiptData.applicationId ||
                                                    receiptData.applicationNo ||
                                                    decryptedVerifyResponse.res.res.applicationId;

                                                console.log("Receipt Data:", receiptData);
                                                // console.log("transactionId:", paymentDetails.transactionId);

                                                if (generatedApplicationId) {
                                                    console.log("Generated Application ID:", generatedApplicationId);

                                                    // Update the application state with the generated applicationId
                                                    this.setState(prevState => ({
                                                        application: {
                                                            ...prevState.application,
                                                            applicationId: generatedApplicationId
                                                        },
                                                        createdId: receiptData._id || receiptData.admissionId // Store the created record ID
                                                    }));

                                                    // Store in localStorage for navigation purposes
                                                    localStorage.setItem('applicationId', generatedApplicationId);
                                                }

                                                // Attach transactionId from decryptedVerifyResponse?.res to receiptData
                                                if (decryptedVerifyResponse?.res?.res?.transactionId) {
                                                    receiptData.transactionId = decryptedVerifyResponse.res.transactionId || decryptedVerifyResponse?.res?.res?.transactionId;
                                                    receiptData.transctionId = decryptedVerifyResponse.res.transactionId || decryptedVerifyResponse?.res?.res?.transactionId; // Also set the misspelled version for compatibility
                                                }

                                                // Set transaction ID from Cashfree payment details or response
                                                const transactionId = decryptedVerifyResponse?.res?.res?.transactionId || paymentDetails?.cf_payment_id || 'N/A';


                                                // Set transaction ID from Cashfree payment details
                                                if (paymentDetails) {
                                                    this.setState({
                                                        // transctionId: 'fsadjfl',
                                                        transctionId: transactionId,
                                                    });
                                                }

                                                // Show success message
                                                if (this.toast) {
                                                    this.toast.show({
                                                        severity: 'success',
                                                        summary: 'Payment Successful',
                                                        detail: 'Application fee paid successfully. Application ID generated.',
                                                        life: 3000
                                                    });
                                                }

                                                // Show success message
                                                // this.toast.show({
                                                //     severity: 'success',
                                                //     summary: 'Payment Successful',
                                                //     detail: 'Payment completed successfully. Receipt generated.',
                                                //     life: 3000
                                                // });
                                                if (this.toast) {
                                                    this.toast.show({
                                                        severity: 'success',
                                                        summary: 'Payment Successful',
                                                        detail: 'Payment completed successfully. Receipt generated.',
                                                        life: 3000
                                                    });
                                                }

                                                // Set receipt data and show receipt dialog
                                                this.setState({
                                                    isEnableReceipt: true,
                                                    receiptData: receiptData,
                                                    openCreateFeeDialog: false,
                                                    isOpenPayFeeDailog: false, // Add this line to close the Pay Fee dialog
                                                    isLoading: false,
                                                    // Clear form data
                                                    payFeeFormData: {},
                                                    transactionDate: null,
                                                    chequeIssuedTo: '',
                                                    chequeNo: '',
                                                    chequeDate: new Date(),
                                                    bankName: '',
                                                    bankBranchName: '',
                                                    destinationBank: '',
                                                    transctionId: '',
                                                    approvalCode: '',
                                                    rrNumber: '',
                                                    userBankName: '',
                                                    cardNo: '',
                                                    isApplicationFeePaid: true,
                                                    isPaymentJustCompleted: true // Flag that payment was just completed

                                                });

                                                // Refresh the term-based data to show updated payment status
                                                // this.getTermBasedData();
                                                this.onCheckFeePaidInfo(true);

                                            }

                                        } catch (error) {
                                            console.error("Error sending payment session details:", error);

                                            // Check if it's an encryption error
                                            if (error.message && error.message.includes('encrypt')) {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Encryption Error',
                                                    detail: 'Failed to encrypt payment verification data',
                                                    life: 3000,
                                                });
                                            } else {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Error',
                                                    detail: 'An error occurred while sending payment session details',
                                                    life: 3000,
                                                });
                                            }
                                        }
                                    };



                                } else {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: decryptedResponse.errMessage || 'Failed to create order (or) Cashfree subMerchantId not found for the organization',
                                        life: 3000,
                                    });
                                }
                            })
                            .catch((error) => {
                                this.setState({ isLoading: false });

                                // Check if it's an encryption error
                                if (error.message && error.message.includes('encrypt')) {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Encryption Error',
                                        detail: 'Failed to encrypt request data',
                                        life: 3000,
                                    });
                                    console.error("Encryption error:", error);
                                } else {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: 'An error occurred while creating order',
                                        life: 3000,
                                    });
                                    console.error("Error in Cashfree order creation:", error);
                                }
                            });
                    }; break;
                    case 'ntt_data': {
                        // NTT Data Payment Gateway Integration
                        console.log('Trigger in NTT PGType case')
                        this.handleNTTDataPayment();
                    }; break;
                }
            }
        } else {
            this.toast.show({ severity: 'error', summary: 'Please Check Validation', detail: 'Please Fill Payment Type And Amount', life: 3000 });

        }
    };
    _onProgress = (filesInfo) => { };

    _afterFilesUploaded = (files) => {
        console.log(files);
    };
    _onFilsUploadError = (errMsg) => {
        this.toast.show({ severity: 'error', summary: 'Some error', detail: errMsg, life: 3000 });
    };

    addAttachment = (fieldName, fileName, data) => {
        this.setState((prevState) => ({
            application: {
                ...prevState.application,
                [fieldName]: {
                    fileName,
                    storageBucket: data.Bucket,
                    storageKey: data.Key,
                    storageLocation: data.Location
                }
            }
        }));
    };

    _onStudenPhotoSuccess = (fileName, data) => {
        this.addAttachment('studentPhoto', fileName, data);
    };

    onToggleChange = (e, field) => {
        let data = JSON.parse(JSON.stringify(this.state.application));
        let formValidations = this.state.formValidations;
        data[field] = e.value;
        let fieldInfo = createApplicationFields.filter((f) => f.FieldName == field);
        if (formValidations.fields[field].isRequired) {
            if (!data[field]) {
                formValidations.fields[field] = { ...formValidations.fields[field], isValid: false, errorMsg: `${fieldInfo[0].Label} is required.` };
                formValidations.isFormValid = false;
            } else {
                formValidations.fields[field] = { ...formValidations.fields[field], isValid: true, errorMsg: `` };
            }
        }

        this.setState({
            application: data,
            formValidations
        });
    };

    onEmailChange = (value, fieldName, thisObj, formFields, formData, formValidations, formName, formValidationName, optionalRequired) => {
        let data = JSON.parse(JSON.stringify(formData));
        data[fieldName] = value;
        let fieldInfo = formFields.filter((f) => f.FieldName == fieldName);
        fieldInfo = fieldInfo[0];
        if (value != '' && optionalRequired) {
            formValidations.fields[fieldName].isRequired = true
        }
        if (value == '' && optionalRequired) {
            formValidations.fields[fieldName].isRequired = false
        }
        if (formValidations.fields[fieldName].isRequired) {
            if (data[fieldName] == '' || data[fieldName] == null) {
                formValidations.fields[fieldName] = {
                    ...formValidations.fields[fieldName],
                    isValid: false,
                    errorMsg: `${fieldInfo.RequiredMsg ? fieldInfo.RequiredMsg : fieldInfo.Label + ' is required'}`
                }
                formValidations.isFormValid = false;
            }
            // else if ((data[fieldName] != '' && data[fieldName] != null) && !isValidEmail(data[fieldName])) {
            //     formValidations.fields[fieldName] = {
            //         ...formValidations.fields[fieldName],
            //         isValid: false,
            //         errorMsg: `${fieldInfo.Label} is invalid.`
            //     }
            //     formValidations.isFormValid = false;
            // } 
            else {
                formValidations.fields[fieldName] = {
                    ...formValidations.fields[fieldName],
                    isValid: true,
                    errorMsg: ``
                }
            }
        } else {
            if (optionalRequired && value == '') {
                formValidations.fields[fieldName] = {
                    ...formValidations.fields[fieldName],
                    isValid: true,
                    errorMsg: ``
                }
            }
        }

        thisObj.setState({
            [formName]: data,
            [formValidationName]: formValidations
        });
    }

    onSetClasses = () => {
        const { dob, application, ageCriteriaInfo, admissionSettingsInfo, selectedClassesList } = this.state
        if (admissionSettingsInfo?.ageCriteria) {
            let classesInfo
            if (dob && application?.board) {
                // Check if age criteria data exists for the selected board
                if (!ageCriteriaInfo || !Array.isArray(ageCriteriaInfo) || ageCriteriaInfo.length === 0) {
                    // No age criteria configured for this board, show all grades
                    this.setState({
                        classes: selectedClassesList || []
                    });
                    return;
                }

                // Check if any grade has valid dates configured (not null/undefined)
                const hasValidDates = ageCriteriaInfo.some(cls =>
                    cls.bornBefore && cls.bornAfter &&
                    cls.bornBefore !== null && cls.bornAfter !== null
                );

                if (!hasValidDates) {
                    // Dates not configured for this board, show all grades
                    this.setState({
                        classes: selectedClassesList || []
                    });
                    return;
                }

                // Age criteria is configured with valid dates, filter based on DOB
                classesInfo = ageCriteriaInfo.filter(cls => {
                    // Skip grades without valid dates
                    if (!cls.bornBefore || !cls.bornAfter) return false;

                    const dateOfBirth = new Date(dob.toDateString());
                    const bornBeforeDate = new Date(new Date(cls.bornBefore).toDateString());
                    const bornAfterDate = new Date(new Date(cls.bornAfter).toDateString());

                    return dateOfBirth >= bornAfterDate && dateOfBirth <= bornBeforeDate;
                });
                const classIds = new Set(classesInfo.map(item => item.classId));


                const matchedClasses = selectedClassesList && Array.isArray(selectedClassesList) ? selectedClassesList.filter(item => classIds.has(item.classId)) : [];
                if (!matchedClasses || matchedClasses.length === 0) {
                    // Age criteria is configured but DOB doesn't match any grade - show error
                    this.setState({
                        isLoading: false,
                        classes: [],
                        application: {
                            ...this.state.application,
                            grade: ''
                        }
                    });
                    this.toast?.show({ severity: 'error', summary: 'Age not eligible for any grades', detail: "Age not eligible for any grades", life: 3000 });
                } else {
                    // Check if currently selected grade is still in the matched classes
                    const isSelectedGradeValid = matchedClasses.some(cls => cls.classId === this.state.application.grade);

                    this.setState({
                        classes: matchedClasses,
                        application: {
                            ...this.state.application,
                            grade: isSelectedGradeValid ? this.state.application.grade : ''
                        }
                    })
                }
            } else if (!dob) {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Please select DOB', detail: "Please select DOB", life: 3000 });
            } else {
                this.setState({
                    classes: selectedClassesList || []
                })
            }

        } else {
            this.setState({
                classes: selectedClassesList || []
            })
        }


    }

    getAgeCriteriaInfo = async (branchId, boardId, finalClassesList) => {
        this.setState({
            isLoading: true
        });
        const { dob, application, admissionSettingsInfo, ageCriteriaInfo } = this.state
        const academicYear = application?.academicSession || localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admissions/agecriteria?boardId=${boardId}&branchId=${branchId}&academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                // Set both ageCriteriaInfo and selectedClassesList before calling onSetClasses
                this.setState({
                    ageCriteriaInfo: res?.res?.data,
                    selectedClassesList: finalClassesList || [],
                    isLoading: false
                }, () => this.onSetClasses());
            } else {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Error', detail: res?.message, life: 3000 });
            }
        } catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
            this.toast?.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 });
        }
    }

    render() {
        const { application, formValidations, payFeeFormData, payFormValidations } = this.state;

        console.log('🎨 Render method called');
        console.log('📊 Current state:', {
            isEdit: this.state.isEdit,
            isAddApplication: this.state.isAddApplication,
            loadedFromReferenceNo: this.state.loadedFromReferenceNo,
            hasApplication: !!this.state.application?._id,
            applicationKeys: Object.keys(this.state.application || {}),
            firstName: this.state.application?.firstName,
            lastName: this.state.application?.lastName,
            branch: this.state.application?.branch,
            board: this.state.application?.board
        });
        console.log('📋 Full application object:', application);
        console.log('👨‍👩‍👧 Parents in render:', this.state.parents);
        console.log('👶 Siblings in render:', this.state.siblings);

        // Force form display if loaded from referenceNo
        const urlParams = new URLSearchParams(window.location.search);
        const referenceNo = urlParams.get('referenceNo');

        if (referenceNo) {
            console.log('🎯 ReferenceNo detected in render, forcing form display');
        }

        return (

            <>
                <div className=''>
                    <br />
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Academic Details</u>
                        </h1>
                    </div>

                    {/* Admission Year, Academic Category */}
                    <div className="grid  md:col-12 lg:rid-col-12 mx-5 column-gap-8 row-gap-5" >
                        <div className="col-span-1">

                            {/* application id */}
                            <p className='transport-fee-form-label'>Application ID<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    height={48}
                                    value={application.applicationId}
                                    // onChange={(e) => onInputChange(e, 'applicationId', this, formFields, application, formValidations, 'application', 'formValidations')}
                                    className='text-xl add-vehicle-field-input w-full'
                                    placeholder='Application ID'
                                    disabled={true}
                                />
                            </div>
                        </div>
                        {/* Academic Year dropdown to use the same data source as AppTopbar */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Academic Year<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    height={48}
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={
                                        (() => {
                                            const userAcademicYear = localStorage.getItem('userAcademicYear');
                                            const matchingSession = this.state.academicSession?.find(session => session.value === userAcademicYear);
                                            return matchingSession?.label || application.academicYearCode || application.enquiry?.academicYearCode || userAcademicYear || '';
                                        })()
                                    }
                                    placeholder='Academic Year'
                                    disabled={true}
                                />
                            </div>
                            {formValidations && !formValidations.fields['academicSession']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['academicSession']?.errorMsg}</p>
                            )}
                        </div>

                        {/* Admission Category dropdown */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Admission Category<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    height={48}
                                    //
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.academicCategory}
                                    options={this.state.academicCategory || []}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'academicCategory', this, formFields, application, formValidations, 'application', 'formValidations') }}
                                    placeholder='Admission Category'
                                />
                            </div>
                            {formValidations && !formValidations.fields['academicCategory'].isValid && <p className="p-error text-lg">{formValidations.fields['academicCategory'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* Branch board grade */}
                    <div className="grid  md:col-12 lg:rid-col-12 mx-5 column-gap-8 row-gap-5" >
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Branch<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    height={48}
                                    //
                                    optionLabel='name'
                                    optionValue='key'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.branch}
                                    options={this.props.branchData}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'branch', this, formFields, application, formValidations, 'application', 'formValidations'); this.onChangeBranch(e.target.value) }}
                                    placeholder='Select Branch'
                                />
                            </div>
                            {formValidations && !formValidations.fields['branch'].isValid && <p className="p-error text-lg">{formValidations.fields['branch'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Board<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    //
                                    optionLabel='boardName'
                                    optionValue='boardId'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.board}
                                    options={this.state.boards}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'board', this, formFields, application, formValidations, 'application', 'formValidations'); this.onChangeBoard(e.target.value) }}
                                    placeholder='Select Board'
                                />
                            </div>
                            {formValidations && !formValidations.fields['board'].isValid && <p className="p-error text-lg">{formValidations.fields['board'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Grade<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    //
                                    optionLabel='className'
                                    optionValue='classId'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.grade}
                                    options={this.state?.classes}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'grade', this, formFields, application, formValidations, 'application', 'formValidations'); this.onChangeClass(e.target.value) }}
                                    placeholder='Select Grade'
                                />
                            </div>
                            {formValidations && !formValidations.fields['grade'].isValid && <p className="p-error text-lg">{formValidations.fields['grade'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* Prev  Branch board grade */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Previous School<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    //
                                    className=' add-vehicle-field-input w-full '
                                    value={application.previousSchool}
                                    onChange={(e) => onTextChange(e.target.value, 'previousSchool', this, formFields, application, formValidations, 'application', 'formValidations')}
                                    placeholder="Previous School" />
                            </div>
                            {formValidations && !formValidations.fields['previousSchool'].isValid && <p className="p-error text-lg">{formValidations.fields['previousSchool'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">

                            <p className='transport-fee-form-label'>Previous Board<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.previousBoard}
                                    options={this.state.previousBoards}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'previousBoard', this, formFields, application, formValidations, 'application', 'formValidations') }}
                                    placeholder='Select Previous Board'
                                />
                            </div>
                            {formValidations && !formValidations.fields['previousBoard'].isValid && <p className="p-error text-lg">{formValidations.fields['previousBoard'].errorMsg}</p>}
                        </div>


                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Previous Grade<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.previousGrade}
                                    // options={this.state.classStudyingDrp}
                                    options={gradePriorityOptions}
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'previousGrade', this, formFields, application, formValidations, 'application', 'formValidations');
                                    }}
                                    placeholder='Select Previous Grade'
                                />
                            </div>
                            {formValidations && !formValidations.fields['previousGrade']?.isValid && <p className="p-error text-lg">{formValidations.fields['previousGrade']?.errorMsg}</p>}
                        </div>
                    </div>

                    {/* Student | Personal Details */}
                    <br />
                    <div className='ml-6 mt-5'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Personal Details</u>
                        </h1>
                    </div>
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student First Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    //
                                    // id="title"
                                    width={250}
                                    className='  add-vehicle-field-input w-full '
                                    value={application.firstName}
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'firstName', this, formFields, application, formValidations, 'application', 'formValidations');
                                        }
                                    }}
                                    placeholder="Student First Name" />
                            </div>
                            {formValidations && !formValidations.fields['firstName'].isValid && <p className="p-error text-lg">{formValidations.fields['firstName'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student Middle Name</p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    className='add-vehicle-field-input w-full'
                                    value={application.middleName} // Corrected field
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'middleName', this, formFields, application, formValidations, 'application', 'formValidations'); // Corrected field
                                        }
                                    }}
                                    placeholder="Student Middle Name"
                                />
                            </div>
                            {formValidations && !formValidations.fields['middleName']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['middleName']?.errorMsg}</p> // Corrected field
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student Last Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    //
                                    // id="title"
                                    width={250}
                                    className='  add-vehicle-field-input w-full '
                                    value={application.lastName}
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'lastName', this, formFields, application, formValidations, 'application', 'formValidations')
                                        }
                                    }}
                                    placeholder="Student Last Name" />
                            </div>
                            {formValidations && !formValidations.fields['lastName'].isValid && <p className="p-error text-lg">{formValidations.fields['lastName'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* Gender, DOB, Upload photo */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Gender<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}

                                    //
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.gender}
                                    options={this.state.gender}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'gender', this, formFields, application, formValidations, 'application', 'formValidations') }}
                                    placeholder='Select Gender'
                                />
                            </div>
                            {formValidations && !formValidations.fields['gender'].isValid && <p className="p-error text-lg">{formValidations.fields['gender'].errorMsg}</p>}

                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Date of Birth<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetCalendar
                                    width={250}
                                    //
                                    className=' border-round-md add-vehicle-field-input text-xl w-full'
                                    calendarMode={'single'}
                                    // value={application.dob}
                                    value={application.dob ? new Date(application.dob) : null}
                                    onChange={(e) => {
                                        this.setState({
                                            dob: e.value,
                                            application: { ...this.state.application, dob: e.value }
                                        }, () => {
                                            // Re-fetch age criteria if board and branch are selected
                                            if (this.state.application?.board && this.state.application?.branch) {
                                                this.getAgeCriteriaInfo(
                                                    this.state.application.branch,
                                                    this.state.application.board,
                                                    this.state.selectedClassesList
                                                );
                                            } else {
                                                this.onSetClasses();
                                            }
                                        })
                                    }}
                                    placeholder="DOB"
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>
                        <div className="col-span-1">
                            <p className="transport-fee-form-label">
                                Upload Photo
                            </p>
                            <div className="flex">
                                <FileUpload
                                    id={'student'}
                                    multiple={false}
                                    onProgress={this._onProgress}
                                    onSucess={this._onStudentPhotoSuccess} // Note: It's 'onSucess' not 'onSuccess' (matching registration.js)
                                    maxFileSize={5242880} // 5MB in bytes
                                    onError={this._onFilesUploadError} // Note: It's '_onFilsUploadError' not '_onFilesUploadError' (matching registration.js)
                                    accept={'images'} // Changed to 'images' to match registration.js
                                    title={'Upload Student Photo'}
                                    afterFilesUploaded={this._afterFilesUploaded}
                                    className="border-solid"
                                    disabled={this.state.isLoading}
                                >
                                    <ClassetInputText
                                        width={250}
                                        icon={<FileAttachmentIcon width={24} height={24} color={'black'} />}
                                        className="add-vehicle-field-input w-full"
                                        value={application.studentPhoto?.fileName || ''}
                                        placeholder="Upload Photo"
                                        disabled={true}
                                    />
                                </FileUpload>
                            </div>
                            {formValidations && !formValidations.fields['studentPhoto']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['studentPhoto']?.errorMsg}</p>
                            )}
                        </div>
                    </div>

                    {/* Nationality, Govt Id, id details */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        {/* nationality */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Nationality</p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='name'
                                    optionValue='code'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.nationality}
                                    options={this.state.countries}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'nationality', this, formFields, application, formValidations, 'application', 'formValidations') }}
                                    placeholder='Select Nationality'
                                />
                            </div>
                            {formValidations && !formValidations.fields['nationality']?.isValid && <p className="p-error text-lg">{formValidations.fields['nationality']?.errorMsg}</p>}
                        </div>


                        {/* Gov ID */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Govt ID<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.govtIdType}
                                    options={this.state.govtIdTypes}
                                    onChange={(e) => {
                                        this.onGovtIdTypeChange(e.target.value);
                                    }}
                                    placeholder='Select Govt ID'
                                />
                            </div>
                            {formValidations && !formValidations.fields['govtIdType']?.isValid && <p className="p-error text-lg">{formValidations.fields['govtIdType']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>ID Details<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    keyfilter={application.govtIdType === 'aadhaar' ? 'int' : null} // Only allow numbers for Aadhaar
                                    maxLength={application.govtIdType === 'aadhaar' ? 12 : application.govtIdType === 'passport' ? 8 : undefined}
                                    className='add-vehicle-field-input w-full'
                                    value={application.idDetails}
                                    onChange={(e) => {
                                        let value = e.target.value;

                                        // Apply specific filters based on govt ID type
                                        if (application.govtIdType === 'aadhaar') {
                                            // Only allow digits for Aadhaar
                                            value = value.replace(/\D/g, '');
                                            if (value.length > 12) value = value.slice(0, 12);
                                        } else if (application.govtIdType === 'passport') {
                                            // Only allow alphanumeric for Passport
                                            value = value.replace(/[^A-Za-z0-9]/g, '');
                                            if (value.length > 8) value = value.slice(0, 8);
                                            value = value.toUpperCase(); // Convert to uppercase for consistency
                                        }

                                        this.onIdDetailsChange(value);
                                    }}
                                    placeholder={
                                        application.govtIdType === 'aadhaar' ? "Enter Aadhaar number"
                                            : application.govtIdType === 'passport'
                                                ? "Enter Passport number"
                                                : "Enter ID Details"
                                    }
                                    disabled={!application.govtIdType} // Disable if no govt ID type is selected
                                />
                            </div>
                            {formValidations && !formValidations.fields['idDetails']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['idDetails']?.errorMsg}</p>
                            )}
                            {/* Show format hint */}
                            {application.govtIdType && (
                                <small className="p-text-secondary">
                                    {application.govtIdType === 'aadhaar' && "Format: 12 digits (e.g., 123456789012)"}
                                    {application.govtIdType === 'passport' && "Format: 8 alphanumeric characters (e.g., A1234567)"}
                                </small>
                            )}
                        </div>
                        <div className="">
                            <p className="transport-fee-form-label">Blood Group</p>
                            <div className="flex">
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    placeholder="Select Blood Group"
                                    className="add-vehicle-field-input"
                                    value={application.bloodGroup}
                                    options={[
                                        { label: 'A+', value: 'A+' },
                                        { label: 'A-', value: 'A-' },
                                        { label: 'B+', value: 'B+' },
                                        { label: 'B-', value: 'B-' },
                                        { label: 'O+', value: 'O+' },
                                        { label: 'O-', value: 'O-' },
                                        { label: 'AB+', value: 'AB+' },
                                        { label: 'AB-', value: 'AB-' }
                                    ]}
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            application: {
                                                ...prevState.application,
                                                bloodGroup: e.value
                                            }
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Religion, Mother Tongue, Caste */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Religion</p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.religion}
                                    options={this.state.religions}
                                    onChange={(e) => onDropDownChange(e.target.value, 'religion', this, formFields, application, formValidations, 'application', 'formValidations')}
                                    placeholder='Select Religion'
                                />
                            </div>
                            {formValidations && !formValidations.fields['religion']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['religion']?.errorMsg}</p>
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Mother Tongue<span className='ma-required'></span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    className='add-vehicle-field-input w-full'
                                    value={application.motherTongue}
                                    // onChange={(e) => onTextChange(e.target.value, 'motherTongue', this, formFields, application, formValidations, 'application', 'formValidations')}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Allow only letters and spaces
                                        onTextChange(value, 'motherTongue', this, formFields, application, formValidations, 'application', 'formValidations');
                                    }}
                                    placeholder="Enter Language"
                                />
                            </div>
                            {formValidations && !formValidations.fields['motherTongue']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['motherTongue']?.errorMsg}</p>
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Caste</p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.caste}
                                    options={this.state.castes}
                                    onChange={(e) => onDropDownChange(e.target.value, 'caste', this, formFields, application, formValidations, 'application', 'formValidations')}
                                    placeholder='Select Caste'
                                />
                            </div>
                            {formValidations && !formValidations.fields['caste']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['caste']?.errorMsg}</p>
                            )}
                        </div>


                    </div>

                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >


                        {/* // The Country Code dropdown remains the same - it will now use the JSON data */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Country Code</p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={application.stdCountryCode}
                                    options={this.state.countryPhoneCodes} // This now uses JSON data
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'stdCountryCode', this, formFields, application, formValidations, 'application', 'formValidations');
                                    }}
                                    placeholder='Select Country Phone Code'
                                />
                            </div>
                            {formValidations && !formValidations.fields['stdCountryCode']?.isValid && <p className="p-error text-lg">{formValidations.fields['stdCountryCode']?.errorMsg}</p>}
                        </div>

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Contact no</p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    keyfilter='int'
                                    maxLength={10}
                                    //
                                    className='  add-vehicle-field-input w-full '
                                    value={application.stdContactNo}
                                    onChange={(e) => this.onContactNumberChange(e.target.value, 'stdContactNo')}
                                    placeholder="Contact No (10 digits)" />
                            </div>
                            {formValidations && !formValidations.fields['stdContactNo']?.isValid && <p className="p-error text-lg">{formValidations.fields['stdContactNo']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Email ID</p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    //
                                    className='  add-vehicle-field-input w-full '
                                    value={application.stdEmailId}
                                    onChange={(e) => this.onEmailChangeWithValidation(e.target.value, 'stdEmailId')}
                                    placeholder="Email ID" />
                            </div>
                            {formValidations && !formValidations.fields['stdEmailId']?.isValid && <p className="p-error text-lg">{formValidations.fields['stdEmailId']?.errorMsg}</p>}
                        </div>
                        <div className="">
                            <p className="transport-fee-form-label">Current Location</p>
                            <div className="flex">
                                <ClassetInputText
                                    width={250}
                                    className="add-vehicle-field-input w-full"
                                    value={application.currentLocation}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Allow only letters and spaces
                                        onTextChange(value, 'currentLocation', this, formFields, application, formValidations, 'application', 'formValidations');
                                    }}
                                    placeholder="Enter Current Location"
                                />
                            </div>
                            {formValidations && !formValidations.fields['currentLocation']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['currentLocation']?.errorMsg}</p>
                            )}
                        </div>
                    </div>


                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                        {/* <div className="grid md:col-12 lg:col-12 column-gap-8 row-gap-5 mx-5 my-2"> */}
                        <div className="">
                            <p className="transport-fee-form-label">Identification Marks</p>
                            <div className="flex">
                                <ClassetTextArea
                                    width={680}

                                    placeholder="Enter Identification Marks"
                                    className="add-vehicle-field-input w-full"
                                    // style={{ width: '100%' }} // Ensure full width
                                    value={application.identificationMarks}
                                    onChange={(e) =>
                                        onTextChange(
                                            e.target.value,
                                            'identificationMarks',
                                            this,
                                            formFields,
                                            application,
                                            formValidations,
                                            'application',
                                            'formValidations'
                                        )
                                    }
                                />
                            </div>
                            {formValidations && !formValidations.fields['identificationMarks']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['identificationMarks']?.errorMsg}</p>
                            )}
                        </div>
                        {/* </div> */}
                    </div>

                    <div className='ml-6 mt-5'>
                        <h1 className='text-2xl font-bold text-black mb-1 ' style={{ color: 'black' }}>
                            <u>Parent Details</u>
                        </h1>
                    </div>
                    <br />

                    {/* // Update the Parent Details section in the render method */}


                    {this.state.parents.map((parent, index) => (
                        <div key={index} className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Relationship<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetDropdown
                                        width={250}
                                        optionLabel='label'
                                        optionValue='value'
                                        className='text-xl add-vehicle-field-input w-full'
                                        value={parent.parentType} // Changed from application.parentType to parent.parentType
                                        options={this.state.parentTypes}
                                        onChange={(e) => { this.onParentChange(e.target.value, index, 'parentType') }}
                                        placeholder='Relationship'
                                    />
                                </div>
                                {index === 0 && formValidations && !formValidations.fields['parentType'].isValid && <p className="p-error text-lg">{formValidations.fields['parentType'].errorMsg}</p>}
                            </div>

                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Parent Name<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={parent.parentName} // Changed from application.parentName to parent.parentName
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentName')}
                                        placeholder="Enter Parent Name"
                                    />
                                </div>
                                {index === 0 && formValidations && !formValidations.fields['parentName'].isValid && <p className="p-error text-lg">{formValidations.fields['parentName'].errorMsg}</p>}
                            </div>

                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Qualification<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={parent.qualification} // Changed from application.qualification to parent.qualification
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'qualification')}
                                        placeholder="Enter Qualification"
                                    // keyfilter='alpha'

                                    />
                                </div>
                            </div>

                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Profession<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={parent.profession} // Changed from application.profession to parent.profession
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'profession')}
                                        placeholder="Enter Profession"
                                    // keyfilter='alpha'

                                    />
                                </div>
                            </div>

                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Country Code<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetDropdown
                                        width={250}
                                        optionLabel='label'
                                        optionValue='value'
                                        className='text-xl add-vehicle-field-input w-full'
                                        value={parent.countryCode} // Changed from application.countryCode to parent.countryCode
                                        options={this.state.countryPhoneCodes}
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'countryCode')}
                                        placeholder='Select Country Phone Code'
                                    />
                                </div>
                                {index === 0 && formValidations && !formValidations.fields['countryCode'].isValid && <p className="p-error text-lg">{formValidations.fields['countryCode'].errorMsg}</p>}
                            </div>

                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Parent/Guardian Contact No.<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        keyfilter='int'
                                        maxLength={10}
                                        className=' add-vehicle-field-input w-full '
                                        value={parent.parentContact} // Changed from application.parentContact to parent.parentContact
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentContact')}
                                        placeholder="Contact No. (10 digits)"
                                    />
                                </div>
                                {this.state.parentValidations[index]?.parentContact && !this.state.parentValidations[index]?.parentContact?.isValid ? (
                                    <p className="p-error text-lg">{this.state.parentValidations[index]?.parentContact?.errorMsg}</p>
                                ) : (index === 0 && formValidations && !formValidations.fields['parentContact'].isValid && (
                                    <p className="p-error text-lg">{formValidations.fields['parentContact'].errorMsg}</p>
                                ))}
                            </div>

                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Parent/Guardian Email ID<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='  add-vehicle-field-input w-full '
                                        value={parent.parentEmailId} // Changed from application.parentEmailId to parent.parentEmailId
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentEmailId')}
                                        placeholder="Parent/Guardian Email ID"
                                    />
                                </div>
                                {this.state.parentValidations[index]?.parentEmailId && !this.state.parentValidations[index]?.parentEmailId?.isValid ? (
                                    <p className="p-error text-lg">{this.state.parentValidations[index]?.parentEmailId?.errorMsg}</p>
                                ) : (index === 0 && formValidations && !formValidations.fields['parentEmailId'].isValid && (
                                    <p className="p-error text-lg">{formValidations.fields['parentEmailId'].errorMsg}</p>
                                ))}
                            </div>

                            <div className="col-span-1 flex align-items-center">
                                <Button icon="pi pi-plus" aria-label="Add Parent" onClick={() => this.addParent()} style={{ marginRight: '5px' }} />
                                {this.state.parents.length > 1 && (
                                    <Button icon="pi pi-minus" aria-label="Remove Parent" onClick={() => this.removeParent(index)} />
                                )}
                            </div>
                        </div>
                    ))}



                    {/* Remarks */}
                    <div className="grid md:col-12 lg:col-12 column-gap-8 row-gap-5 mx-5 my-2">
                        <div className="" >
                            <p className="transport-fee-form-label">Remarks</p>
                            <div className="flex">
                                <ClassetTextArea
                                    placeholder='Remarks'
                                    className=""
                                    width={680}
                                    value={application.remarks}
                                    onChange={(e) => onTextChange(e.target.value, 'remarks', this, formFields, application, formValidations, 'application', 'formValidations')}
                                />
                            </div>
                            {formValidations && !formValidations.fields['remarks'].isValid && <p className="p-error text-lg">{formValidations.fields['remarks'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* SIBLINGS */}
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Siblings</u>
                        </h1>
                    </div>
                    <br />
                    <div className='p-grid ma-w100p mx-5 ma-p20 mb-5'>
                        <DataTable ref={(el) => this.dt = el}
                            value={this.state.siblings}>
                            <Column header='Sl.No' className='ma-w100 ma-h100' body={(rowData, index) => {
                                return (<span>{index.rowIndex + 1}</span>)
                            }} />
                            <Column header="Name" body={(rowData, index) => {
                                return (
                                    <ClassetInputText
                                        value={this.state.siblings[index.rowIndex].name}
                                        width={250}
                                        placeholder="Enter Name"
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "name", "siblings")}
                                    />
                                )
                            }} />
                            <Column header="Gender" body={(rowData, index) => {
                                return (
                                    <ClassetDropdown disabled={this.state.hideUpdateButton}
                                        options={this.state.genderData} optionLabel='label' optionValue='value'
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].gender}
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "gender", "siblings")}
                                        placeholder="Select Gender" />
                                )
                            }} />
                            <Column header="Class Studying" body={(rowData, index) => {
                                return (
                                    <ClassetDropdown disabled={this.state.hideUpdateButton}
                                        // options={this.state.classStudyingDrp} 
                                        options={this.state.classStudyingDrp}
                                        optionLabel='label' optionValue='value'
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].classStudying}
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "classStudying", "siblings")}
                                        placeholder="Select Class" />
                                )
                            }} />
                            <Column header="School Studying" body={(rowData, index) => {
                                return (
                                    <ClassetInputText
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].schoolStudying}
                                        placeholder="Enter School Studying"
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "schoolStudying", "siblings")}
                                    />
                                )
                            }} />
                            <Column header="" body={(rowData, index) => {
                                return (
                                    <div className="flex flex-column align-items-center justify-content-center gap-2">
                                        <Button icon="pi pi-plus" aria-label="Increase" onClick={() => this.onCliclAddSibling(true, index.rowIndex)} />
                                        {this.state.siblings.length > 1 && <Button icon="pi pi-minus" aria-label="Decrease" onClick={() => this.onCliclAddSibling(false, index.rowIndex)} />}
                                    </div>
                                )
                            }} />
                        </DataTable>
                    </div>

                    {/* ADDRESS */}
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black ' style={{ color: 'black' }}>
                            <u>Address</u>
                        </h1>
                    </div>
                    {/* <br /> */}
                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >
                        {/* Address Line */}
                        <div className="col-span-1">
                            <p className="transport-fee-form-label">
                                Address Line<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetInputText
                                    width={1300}
                                    // style={{ width: '100vw' }} // Updated to use 100%
                                    className="add-vehicle-field-input w-full"
                                    value={application.addressLine}
                                    onChange={(e) =>
                                        onTextChange(
                                            e.target.value,
                                            'addressLine',
                                            this,
                                            formFields,
                                            application,
                                            formValidations,
                                            'application',
                                            'formValidations'
                                        )
                                    }
                                    placeholder="Enter Address Line"
                                />
                            </div>
                            {formValidations && !formValidations.fields['addressLine']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['addressLine']?.errorMsg}</p>
                            )}
                        </div>
                    </div>


                    {/* state, district, pincode */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Pincode<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    className='add-vehicle-field-input w-full'
                                    value={application.pinCode}
                                    width={250}
                                    onChange={(e) => this.onPincodeChange(e.target.value)}
                                    placeholder="Enter Pincode (6 digits)"
                                    keyfilter='int'
                                    maxLength={6}

                                />
                            </div>
                            {formValidations && !formValidations.fields['pinCode']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['pinCode']?.errorMsg}</p>
                            )}
                        </div>
                        {/* state */}

                        <div className="col-span-1  ">
                            <p className='transport-fee-form-label'>State<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    className='add-vehicle-field-input w-full'
                                    value={application.state}
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    options={this.state.state} // Add the options from state
                                    onChange={(e) => this.onStateChange(e.target.value)}
                                    placeholder="Select State"
                                />
                            </div>
                            {formValidations && !formValidations.fields['state']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['state']?.errorMsg}</p>
                            )}
                        </div>


                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>City/District<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    className='add-vehicle-field-input w-full'
                                    value={application.cityOrDist}
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    options={this.state.cityOrDist} // Add the options from state
                                    onChange={(e) =>
                                        onDropDownChange(
                                            e.target.value,
                                            'cityOrDist',
                                            this,
                                            formFields,
                                            application,
                                            formValidations,
                                            'application',
                                            'formValidations'
                                        )
                                    }
                                    placeholder="Select City/District"
                                />
                            </div>
                            {formValidations && !formValidations.fields['cityOrDist']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['cityOrDist']?.errorMsg}</p>
                            )}
                        </div>


                    </div>

                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">

                    </div>


                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                        {/* Transport Required Checkbox */}

                        <div className="col-span-1 flex align-items-center">
                            <input
                                type="checkbox"
                                id="transportRequired"
                                checked={!!application.transportRequired}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    this.setState({
                                        application: {
                                            ...application,
                                            transportRequired: checked,
                                            requestedStop: checked ? application.requestedStop : '' // Clear requestedStop if unchecked
                                        }
                                    });
                                    // Optionally, clear validation error for requestedStop when unchecked
                                    if (!checked) {
                                        this.setState(prevState => ({
                                            formValidations: {
                                                ...prevState.formValidations,
                                                fields: {
                                                    ...prevState.formValidations.fields,
                                                    requestedStop: {
                                                        isValid: true,
                                                        errorMsg: ''
                                                    }
                                                }
                                            }
                                        }));
                                    }
                                }}
                                style={{ width: 18, height: 18, marginRight: 8 }}
                            />
                            <label htmlFor="transportRequired" className='transport-fee-form-label'>Transport Required</label>
                        </div>



                        {/* Admission Test Checkbox - fetches value from enquiry if available */}
                        {this.state.admissionSettingsInfo?.examTest && (
                            <div className="col-span-1 flex align-items-center ml-8 ">
                                <input
                                    className='ml-4'
                                    type="checkbox"
                                    id="admissionTest"
                                    checked={!!application.admissionTest}
                                    onChange={(e) =>
                                        this.setState({
                                            application: {
                                                ...application,
                                                admissionTest: e.target.checked
                                            }
                                        })
                                    }
                                    style={{ width: 18, height: 18, marginRight: 8 }}
                                />
                                <label htmlFor="admissionTest" className='transport-fee-form-label '>Admission Test</label>
                            </div>
                        )}
                    </div>

                    {/* Conditionally Render Requested Stop Dropdown */}
                    {application.transportRequired && (
                        // ...existing code...

                        <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                            <div className="">
                                <p className='transport-fee-form-label'>Requested Stop<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={application.requestedStop}
                                        onChange={(e) =>
                                            onTextChange(
                                                e.target.value,
                                                'requestedStop',
                                                this,
                                                formFields,
                                                application,
                                                formValidations,
                                                'application',
                                                'formValidations'
                                            )
                                        }
                                        placeholder='Enter Requested Stop'
                                    />
                                </div>
                                {formValidations && !formValidations.fields['requestedStop']?.isValid && (
                                    <p className="p-error text-lg">{formValidations.fields['requestedStop']?.errorMsg}</p>
                                )}
                            </div>
                        </div>

                    )}



                    {/* </div > */}

                    <div className="text-center mt-8">
                        {/* <Button icon={' text-lg '} label='Save and Proceed to Next Step' onClick={this.onSubmitApplication} className='confirmDialogAcceptBtn  mr-5 w-24rem ' /> */}
                        {
                            this.state.isShowPayFeeButton &&
                            !this.state?.isApplicationFeePaid && (
                                <Button className="add-vehicle-btn mr-3" style={{ paddingLeft: 20, width: 200 }} onClick={() => this.openDailogPayAppFee()}>
                                    Pay Application Fee
                                </Button>
                            )}
                        {/* Always show Save/Update button - don't let validation errors hide it */}
                        {
                            (this.state?.isApplicationFeePaid || this.state.isEdit || this.state.application?._id) &&
                            (
                                <Button icon={' text-lg '} label={!this.state.isEdit ? 'Save ' : 'Save '} onClick={() => this.onSubmitApplication(false)} className="confirmDialogAcceptBtn  mr-3 w-18rem p-5" />
                            )}
                        {/* Show "Save and Proceed" only for new paid applications */}
                        {!this.state.isEdit && this.state?.isApplicationFeePaid &&
                            <Button icon={' text-lg '} label="Save and Proceed to Next Step" onClick={() => this.onSubmitApplication(true)} className="confirmDialogAcceptBtn  mr-3 w-24rem p-5 " />}

                        {/* Fallback button - ensure there's always a save button visible */}
                        {!this.state?.isApplicationFeePaid && !this.state.isEdit && !this.state.application?._id && !this.state.isShowPayFeeButton && (
                            <Button icon={' text-lg '} label="Save Application" onClick={() => this.onSubmitApplication(false)} className="confirmDialogAcceptBtn  mr-3 w-18rem p-5" />
                        )}

                        <Button label="Cancel"
                            style={{
                                background: '#E6E8EA', border: '0px', borderRadius: '12px', maxHeight: '48px', width: '120px', font: "InterSemiBold !important",
                                fontSize: '16px', color: 'black'
                            }}
                            className="confirmDialogCancelBtn p-5" onClick={() => (!this.state.isEdit ? this.props.navigate('/admission-application') : this.setState({ isEdit: false }, () => this.props.onHandleClose()))} />


                    </div>

                    <Dialog
                        isopen={this.state.isOpenPayFeeDailog}
                        visible={this.state.isOpenPayFeeDailog}
                        className="pay-fee"
                        style={{ position: 'fixed', right: '0' }}
                        draggable={false}
                        onHide={this.onHandleCancelPayFee}
                        closable={false}
                        header={() => {
                            return (
                                <div className="mt-2 mb-4">
                                    <h3 className="formhead text-center ">Pay Fee</h3>
                                </div>
                            );
                        }}
                    >
                        <div className="mb-5 ml-5 mr-5">
                            <div>
                                <div className="col-12">
                                    <div className="mt-2">
                                        <ClassetInputText
                                            id="term"
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Fee Type name"
                                            value={`${this.state.feePayInfo?.feeName || ''}`}
                                            disabled={true}
                                            onChange={(e) => onTextChange(e.target.value, 'FeeTypeName', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}
                                        />
                                    </div>
                                    {payFormValidations && !payFormValidations.fields['FeeTypeName'].isValid && <p className="p-error">{payFormValidations.fields['FeeTypeName'].errorMsg}</p>}
                                </div>

                                <div className="col-12">
                                    <div className="mt-2">
                                        <ClassetInputText
                                            id="feeAmount"
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Fee Amount"
                                            disabled={true}
                                            value={`${Number(this.state.feePayInfo?.amount) || 0}`}
                                            onChange={(e) => onTextChange(e.target.value, 'feeAmount', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}
                                        />
                                    </div>
                                    {payFormValidations && !payFormValidations.fields['feeAmount'].isValid && <p className="p-error">{payFormValidations.fields['feeAmount'].errorMsg}</p>}
                                </div>
                                <div className="col-12">
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            id="paymentType"
                                            className=""
                                            height="48px"
                                            width="368px"
                                            options={this.state.paymentModes}
                                            value={payFeeFormData.paymentType}
                                            onChange={(e) => {
                                                onDropDownChange(e.target.value, 'paymentType', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations);
                                            }}
                                            placeholder={
                                                <div>
                                                    <span className="">Payment Type</span>
                                                </div>
                                            }
                                        />
                                    </div>
                                    {payFormValidations && !payFormValidations.fields['paymentType'].isValid && <p className="p-error">{payFormValidations.fields['paymentType'].errorMsg}</p>}
                                </div>
                                {(
                                    // payFeeFormData.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' ||
                                    payFeeFormData.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                                    payFeeFormData.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f'
                                    // payFeeFormData.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
                                ) && (
                                        <div className="col-12">
                                            <label className="label mb-2 ">
                                                Transaction Id<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText className="" height="48px" width="368px" placeholder="Enter Transaction Id" value={this.state.transctionId} onChange={(e) => this.setState({ transctionId: e.target.value })} />
                                            </div>
                                        </div>
                                    )}
                                {payFeeFormData.paymentType && (
                                    <div className="col-12">
                                        <label className="label mb-2 ">
                                            Remarks<span className="ma-required"></span>
                                        </label>
                                        <div className="mt-2">
                                            <ClassetTextArea
                                                id="feeType"
                                                className=""
                                                height="48px"
                                                width="368px"
                                                placeholder="Enter Remarks"
                                                value={payFeeFormData.remarks}
                                                onChange={(e) => onTextChange(e.target.value, 'remarks', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="flex justify-content-center mb-4 mt-4">
                                    <Button className="formSubmitButtonn mr-2" style={{ borderRadius: '12px', fontSize: '16px', backgroundColor: '#076EFF' }}
                                        // onClick={this.OnPayFee}
                                        onClick={this.handlePayment}
                                    >
                                        <AddIcon2 />
                                        <p className="formSubmitButtonnText">Pay Now</p>
                                    </Button>
                                    <Button className="cancelButtonn w-4" onClick={this.onHandleCancelPayFee}>
                                        <p className="cancelButtonnText">Cancel</p>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Dialog>
                    {this.state.isShowReceipt && (
                        <FeeReciept
                            receiptData={this.state?.receiptInfo}
                            hideFeeReciept={() => {
                                this.setState({
                                    isShowReceipt: false,
                                    receiptInfo: {}
                                });
                            }}
                        />
                    )}
                    {this.state.isLoading && (
                        <>
                            <LoadingComponent />
                        </>
                    )}
                    <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                </div >
                {
                    this.state.isLoading && <>
                        <LoadingComponent />
                    </>
                }
                < Toast ref={(el) => this.toast = el
                } position="bottom-right" />

                {/* NTT Payment Component */}
                <NTTPaymentComponent
                    showPaymentButton={this.state.showNTTPayment}
                    paymentData={this.state.nttPaymentData}
                    onPaymentSuccess={this.onNTTPaymentSuccess}
                    onPaymentError={this.onNTTPaymentError}
                    onPaymentCancel={this.onNTTPaymentCancel}
                />


            </>
        );
    }
}
const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {}
});
export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(Authentication(withRouter(ApplicationCreate)));


const gradePriorityOptions = Object.entries(gradesEnum).map(([label, value]) => ({
    //   label: `${label} (Priority: ${value})`,
    label: `${label}`,
    value: value
}));